<template>
  <div class="content-wrapper">
    <!-- Page Loader -->
    <div class="vld-parent">
      <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
    </div>

    <breadcrumb :page="$t('form.student.create')"></breadcrumb>

    <div class="content">
      <div class="container-fluid">
        <b-alert v-model="alert" :variant="alertClass" dismissible fade>{{
          alertMessage
        }}</b-alert>

        <div class="card">
          <div class="card-header bg-light">
            <div class="card-title">{{ $t("form.student.create") }}</div>
            <button
              type="submit"
              class="btn btn-primary float-right"
              @click="createStudent()"
            >
              {{ $t("button.save") }}
            </button>
          </div>

          <div class="card-body">
            <b-tabs content-class="mt-3">
              <b-tab :title="$t('form.student.tabPersonal')" active>
                <div class="row">
                  <div class="col-sm-6 col-md-4">
                    <div class="row">
                      <div class="col-7 mt-3">
                        <input
                          type="file"
                          ref="profile_image"
                          style="display: none"
                          @input="showSelectedImage"
                          accept="image/*"
                        />
                        <img
                          :src="image"
                          @click="$refs.profile_image.click()"
                          class="img-responsive"
                          style="
                            cursor: pointer;
                            max-width: 250px;
                            max-height: 250px;
                          "
                        />
                      </div>
                    </div>

                    <hr />

                    <div class="row">
                      <div class="form-group col-12">
                        <label>{{ $t("form.student.programStart") }}</label>
                        <date-picker
                          :lang="lang"
                          class="date-picker"
                          v-model="student.ProgramStart"
                          valueType="format"
                          :format="dateFormat"
                          :popup-style="{ top: '100%', left: 0 }"
                          :append-to-body="false"
                        >
                        </date-picker>
                      </div>
                      <div class="form-group col-12">
                        <label class="control-label" for="StatusID:">{{
                          $t("form.student.status")
                        }}</label>
                        <v-select
                          label="StatusName"
                          :options="statusList"
                          v-model="status"
                          :reduce="(statusList) => statusList"
                        >
                        </v-select>
                      </div>
                      <div class="form-group col-12">
                        <label
                          class="control-label"
                          for="StudentStatusComment:"
                          >{{ $t("form.student.studentStatusComment") }}</label
                        >
                        <input
                          type="text"
                          name="StudentStatusComment"
                          v-model="status.StatusComment"
                          class="form-control"
                        />
                      </div>
                      <div class="form-group col-12">
                        <label class="control-label" for="StudentStatusDate:">{{
                          $t("form.student.studentStatusDate")
                        }}</label>
                        <date-picker
                          :lang="lang"
                          class="date-picker"
                          v-model="status.StatusDate"
                          valueType="format"
                          :format="dateFormat"
                          :popup-style="{ top: '100%', left: 0 }"
                          :append-to-body="false"
                        >
                        </date-picker>
                      </div>
                      <div class="form-group col-6">
                        <label for="StudentdPermitExpiryDate">{{
                          $t("form.student.permitExpiryDate")
                        }}</label>
                     
                        <date-picker
                          class="date-picker"
                          :lang="lang"
                          :disabled="!permissions.editStudentsPersonalinformation"
                          :class="{ 'is-invalid': isInvalidDate2 }"
                          v-model="student.PermitExpiry"
                          @change="onChangePermitExpiryDate()"
                          valueType="format"
                          :format="dateFormat"
                          :popup-style="{ top: '100%', left: 0 }"
                          :append-to-body="false"
                        >
                        </date-picker>
                      </div>
                      
                      <div class="form-group col-6">
                        <label for="StudentPassportExpiryDate">{{
                          $t("form.student.passportExpiryDate")
                        }}</label>
              
                        <date-picker
                          class="date-picker"
                          :class="{ 'is-invalid': isInvalidDate }"
                          id="passportDate"
                          :lang="lang"
                          :disabled="!permissions.editStudentsPersonalinformation"
                          @change="onChangePassportExpiryDate()"
                          v-model="student.PassportExpiry"
                          valueType="format"
                          :format="dateFormat"
                          :popup-style="{ top: '100%', left: 0 }"
                          :append-to-body="false"
                        >
                        </date-picker>
                      </div>
                      <!-- <div class="col-12">
                                                <button type="button" v-on:click="addStatus()"
                                                    class="btn btn-primary btn-block"
                                                    :disabled="!status.StatusID">{{$t('button.addStatus')}}</button>
                                            </div> -->
                    </div>

                    <!-- <hr> -->

                    <!-- <div class="row">
                                            <div class="col-12">
                                                <div class="table-responsive">
                                                    <table class="table table-bordered table-hover"
                                                        v-if="studentStatus.length">
                                                        <thead>
                                                            <tr>
                                                                <th>{{$t('form.student.status')}}</th>
                                                                <th>{{$t('form.student.statusDate')}}</th>
                                                                <th>{{$t('form.student.statusNote')}}</th>
                                                                <th></th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr v-for="(status , index) in studentStatus"
                                                                v-bind:key="index">
                                                                <td>{{status.StudentStatusName}}</td>
                                                                <td>{{status.StudentStatusDate}}</td>
                                                                <td>{{status.StudentStatusComment}}</td>
                                                                <td class="text-right">
                                                                    <span style="cursor:pointer; color:red"
                                                                        @click="removeStatus(index)">
                                                                        <i class="fa fa-times"></i>
                                                                    </span>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div> -->

                    <div class="row">
                      <div class="form-group col-12">
                        <label for="NoteField">{{
                          $t("form.student.notes")
                        }}</label>
                        <textarea
                          id="NoteField"
                          v-model="student.Notes"
                          rows="3"
                          class="form-control"
                        ></textarea>
                      </div>
                    </div>
                  </div>

                  <div class="col-sm-6 col-md-5">
                    <div class="form-group">
                      <label for="StudentNumberField">
                        {{ $t("form.student.studentNumber") }}
                        <span class="text-danger">*</span>
                      </label>
                      <input
                        id="StudentNumberField"
                        v-model="student.StudentNumber"
                        type="number"
                        class="form-control"
                        disabled
                      />
                    </div>
                    <div
                      class="form-group"
                      v-if="student.PartnerID == 1"
                    >
                      <label for="MatriculationNumField">
                        {{ $t("form.student.matriculationNum") }}
                      </label>
                      <input
                        type="text"
                        id="MatriculationNumField"
                        class="form-control"
                        v-model.trim="$v.student.MatriculationNum.$model"
                        :class="{
                          'is-invalid': $v.student.MatriculationNum.$error,
                        }"
                      />
                      <div
                        class="invalid-feedback"
                        v-if="!$v.student.MatriculationNum.maxLength"
                      >
                        {{
                          $t("form.validation.maxDigits", {
                            num: $v.student.MatriculationNum.$params.maxLength
                              .max,
                          })
                        }}
                      </div>
                    </div>

                    <div class="form-group">
                      <label for="TitleField">{{
                        $t("form.student.title")
                      }}</label>
                      <v-select
                        :options="titles"
                        v-model="student.Title"
                        :reduce="(titles) => titles"
                      >
                      </v-select>
                    </div>

                    <div class="form-group">
                      <label for="FirstNameField">
                        {{ $t("form.student.firstName") }}
                        <span class="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        id="FirstNameField"
                        class="form-control"
                        :class="{ 'is-invalid': $v.student.FirstName.$error }"
                        v-model.trim="$v.student.FirstName.$model"
                      />
                      <div
                        class="invalid-feedback"
                        v-if="!$v.student.FirstName.required"
                      >
                        {{ $t("form.validation.required") }}
                      </div>
                      <div
                        class="invalid-feedback"
                        v-if="!$v.student.FirstName.maxLength"
                      >
                        {{
                          $t("form.validation.maxLength", {
                            num: $v.student.FirstName.$params.maxLength.max,
                          })
                        }}
                      </div>
                    </div>

                    <div class="form-group">
                      <label for="LastNameField">
                        {{ $t("form.student.lastName") }}
                        <span class="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        id="LastNameField"
                        class="form-control"
                        v-model.trim="$v.student.LastName.$model"
                        :class="{ 'is-invalid': $v.student.LastName.$error }"
                      />
                      <div
                        class="invalid-feedback"
                        v-if="!$v.student.LastName.required"
                      >
                        {{ $t("form.validation.required") }}
                      </div>
                      <div
                        class="invalid-feedback"
                        v-if="!$v.student.LastName.maxLength"
                      >
                        {{
                          $t("form.validation.maxLength", {
                            num: $v.student.LastName.$params.maxLength.max,
                          })
                        }}
                      </div>
                    </div>

                    <div class="form-group">
                      <label for="TranscriptNameField">{{
                        $t("form.student.transcriptName")
                      }}</label>
                      <input
                        type="text"
                        id="TranscriptNameField"
                        class="form-control"
                        v-model.trim="student.TranscriptName"
                      />
                    </div>

                    <div class="form-group">
                      <label for="BirthDateField">{{
                        $t("form.student.birthDate")
                      }}</label>
                      <date-picker
                        class="date-picker"
                        :lang="lang"
                        v-model="student.BirthDate"
                        valueType="format"
                        :format="dateFormat"
                        :popup-style="{ top: '100%', left: 0 }"
                        :append-to-body="false"
                        :placeholder="student.BirthDate"
                      >
                      </date-picker>
                    </div>

                    <div class="form-group">
                      <label for="BirthPlaceField">
                        {{ $t("form.student.birthPlace") }}
                        <span class="req text-danger"></span>
                      </label>
                      <input
                        type="text"
                        id="BirthPlaceField"
                        v-model.trim="$v.student.BirthPlace.$model"
                        class="form-control"
                        :class="{ 'is-invalid': $v.student.BirthPlace.$error }"
                      />
                      <div
                        class="invalid-feedback"
                        v-if="!$v.student.BirthPlace.required"
                      >
                        {{ $t("form.validation.required") }}
                      </div>
                      <div
                        class="invalid-feedback"
                        v-if="!$v.student.BirthPlace.maxLength"
                      >
                        {{
                          $t("form.validation.maxLength", {
                            num: $v.student.BirthPlace.$params.maxLength.max,
                          })
                        }}
                      </div>
                    </div>

                    <div class="form-group">
                      <label for="BirthCountry">{{
                        $t("form.student.birthCountry")
                      }}</label>
                      <v-select
                        label="printable_name"
                        :options="countries"
                        v-model="student.BirthCountry"
                        :reduce="(countries) => countries.printable_name"
                      >
                      </v-select>
                    </div>

                    <div class="form-group">
                      <label>
                        {{ $t("form.student.nationality") }}
                      </label>
                      <input
                        type="text"
                        v-model.trim="student.Nationality"
                        class="form-control"
                      />
                    </div>

                    <div class="form-group">
                      <label>{{ $t("form.student.streetAddress") }}</label>
                      <input
                        type="text"
                        v-model.trim="student.StreetAddress"
                        class="form-control"
                      />
                    </div>

                    <div class="form-group">
                      <label>{{ $t("form.student.city") }}</label>
                      <input
                        type="text"
                        v-model.trim="student.City"
                        class="form-control"
                      />
                    </div>

                    <div class="form-group">
                      <label>{{ $t("form.student.zip") }}</label>
                      <input
                        type="text"
                        v-model.trim="student.Zip"
                        class="form-control"
                      />
                    </div>

                    <div class="form-group">
                      <label for="CountryField">{{
                        $t("form.student.country")
                      }}</label>
                      <v-select
                        label="printable_name"
                        :options="countries"
                        v-model.trim="student.Country"
                        :reduce="(countries) => countries.printable_name"
                      >
                      </v-select>
                    </div>

                    <div class="form-group">
                      <label for="PhoneField">{{
                        $t("form.student.phone")
                      }}</label>
                      <input
                        type="text"
                        id="PhoneField"
                        v-model.trim="student.Phone"
                        class="form-control"
                      />
                    </div>

                    <div class="form-group">
                      <label for="MobileField">
                        {{ $t("form.student.mobile") }}
                      </label>
                      <input
                        type="text"
                        id="MobileField"
                        v-model.trim="student.Mobile"
                        class="form-control"
                      />
                    </div>

                    <div class="form-group">
                      <label for="EmailField">
                        {{ $t("form.student.email") }}
                        <span class="text-danger">*</span>
                      </label>
                      <input
                        type="email"
                        id="EmailField"
                        v-model.trim="$v.student.Email.$model"
                        class="form-control"
                        :class="{ 'is-invalid': $v.student.Email.$error }"
                      />
                      <div
                        class="invalid-feedback"
                        v-if="!$v.student.Email.required"
                      >
                        {{ $t("form.validation.required") }}
                      </div>
                      <div
                        class="invalid-feedback"
                        v-if="!$v.student.Email.email"
                      >
                        {{ $t("form.validation.validEmail") }}
                      </div>
                    </div>

                    <div class="form-group">
                      <label for="Email2Field">{{
                        $t("form.student.email2")
                      }}</label>
                      <input
                        id="Email2Field"
                        v-model="student.Email2"
                        type="email"
                        class="form-control"
                      />
                    </div>

                    <div class="form-group">
                      <label for="Email3Field">{{
                        $t("form.student.email3")
                      }}</label>
                      <input
                        id="Email3Field"
                        v-model="student.Email3"
                        type="email"
                        class="form-control"
                      />
                    </div>
                  </div>

                  <div class="col-sm-4 col-md-3 mb-3 ml-auto">
                    <div class="shadow mb-4 p-3">
                      <h6>
                        <u>
                          <b>{{ $t("form.student.mailAddress") }}</b>
                        </u>
                      </h6>
                      <div class="form-group">
                        <label>
                          <input
                            type="radio"
                            v-model="student.MailAddress"
                            value="1"
                          />
                          {{ $t("form.student.mailAddressOption1") }}
                        </label>
                      </div>
                      <div class="form-group">
                        <label>
                          <input
                            type="radio"
                            v-model="student.MailAddress"
                            value="2"
                          />
                          {{ $t("form.student.mailAddressOption2") }}
                        </label>
                      </div>
                    </div>

                    <div class="shadow mb-4 p-3">
                      <h6>
                        <u>
                          <b>{{ $t("form.student.gradeNotify") }}</b>
                        </u>
                      </h6>
                      <div class="form-group">
                        <label>
                          <input type="checkbox" v-model="student.SISEnabled" />
                          {{ $t("form.student.gradeNotifyOption1") }}
                        </label>
                      </div>

                      <div class="form-group">
                        <label>
                          <input
                            type="checkbox"
                            v-model="student.GradeNotification"
                          />
                          {{ $t("form.student.gradeNotifyOption2") }}
                        </label>
                      </div>

                      <div class="form-group">
                        <label>
                          <input
                            type="checkbox"
                            v-model="student.BirthdayNotification"
                          />
                          {{ $t("form.student.gradeNotifyOption3") }}
                        </label>
                      </div>
                    </div>

                    <div class="shadow mb-4 p-3">
                      <h6>
                        <u>
                          <b>{{ $t("form.student.legalization") }}</b>
                        </u>
                      </h6>
                      <div class="form-group">
                        <label>
                          <input
                            type="checkbox"
                            v-model="student.LegalizationRequired"
                          />
                          {{ $t("form.student.legalizationOption1") }}
                        </label>
                      </div>
                    </div>

                    <div class="shadow mb-4 p-3">
                      <div class="form-group">
                        <label for="CodeField">{{
                          $t("form.student.partnerCode")
                        }}</label>
                        <v-select
                          label="PartnerCode"
                          :options="partners"
                          v-model="student.PartnerID"
                          @input="fetchPartnerCampus"
                          :reduce="(partners) => partners.PartnerID"
                        >
                        </v-select>
                      </div>

                      <div class="form-group">
                        <label for="pCodeField">{{
                          $t("form.student.partnerCampus")
                        }}</label>
                        <v-select
                          label="PartnerCampusLocation"
                          :options="partnercampus"
                          v-model="student.PartnerCampusID"
                          :reduce="
                            (partnercampus) => partnercampus.PartnerCampusID
                          "
                          :resetOnOptionsChange="true"
                        >
                        </v-select>
                      </div>
                    </div>
                  </div>
                </div>
              </b-tab>

              <b-tab :title="$t('form.student.tabBusiness')">
                <div class="row">
                  <div
                    class="col-sm-8"
                    v-if="parseInt(student.MailAddress) === 2"
                  >
                    <div class="form-group">
                      <label for="CompanyName:">
                        {{ $t("form.student.companyName") }}
                        <span class="req text-danger">*</span>
                      </label>
                      <input
                        id="CompanyName"
                        type="text"
                        v-model.trim="$v.studentBussiness.CompanyName.$model"
                        name="CompanyName"
                        class="form-control"
                        :class="{
                          'is-invalid': $v.studentBussiness.CompanyName.$error,
                        }"
                      />
                      <div
                        class="invalid-feedback"
                        v-if="!$v.studentBussiness.CompanyName.required"
                      >
                        {{ $t("form.validation.required") }}
                      </div>
                      <div
                        class="invalid-feedback"
                        v-if="!$v.studentBussiness.CompanyName.maxLength"
                      >
                        {{
                          $t("form.validation.maxLength", {
                            num: $v.studentBussiness.CompanyName.$params
                              .maxLength.max,
                          })
                        }}
                      </div>
                    </div>
                    <div class="form-group">
                      <label class for="BusinessDepartment">
                        {{ $t("form.student.department") }}
                        <span class="req text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        id="BusinessDepartment"
                        v-model.trim="$v.studentBussiness.Department.$model"
                        class="form-control"
                        :class="{
                          'is-invalid': $v.studentBussiness.Department.$error,
                        }"
                      />
                      <div
                        class="invalid-feedback"
                        v-if="!$v.studentBussiness.Department.required"
                      >
                        {{ $t("form.validation.required") }}
                      </div>
                      <div
                        class="invalid-feedback"
                        v-if="!$v.studentBussiness.Department.maxLength"
                      >
                        {{
                          $t("form.validation.maxLength", {
                            num: $v.studentBussiness.Department.$params
                              .maxLength.max,
                          })
                        }}
                      </div>
                    </div>
                    <div class="form-group">
                      <label class for="BusinessPosition:">
                        {{ $t("form.student.position") }}
                        <span class="req text-danger">*</span>
                      </label>

                      <input
                        id="BusinessPosition:"
                        name="BusinessPosition"
                        v-model.trim="$v.studentBussiness.Position.$model"
                        class="form-control"
                        :class="{
                          'is-invalid': $v.studentBussiness.Position.$error,
                        }"
                      />
                      <div
                        class="invalid-feedback"
                        v-if="!$v.studentBussiness.Position.required"
                      >
                        {{ $t("form.validation.required") }}
                      </div>
                      <div
                        class="invalid-feedback"
                        v-if="!$v.studentBussiness.Position.maxLength"
                      >
                        {{
                          $t("form.validation.maxLength", {
                            num: $v.studentBussiness.Position.$params.maxLength
                              .max,
                          })
                        }}
                      </div>
                    </div>
                    <div class="form-group">
                      <label class for="StreetAddress:">
                        {{ $t("form.student.streetAddress") }}
                        <span class="req text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        v-model.trim="$v.studentBussiness.StreetAddress.$model"
                        class="form-control"
                        :class="{
                          'is-invalid':
                            $v.studentBussiness.StreetAddress.$error,
                        }"
                      />
                      <div
                        class="invalid-feedback"
                        v-if="!$v.studentBussiness.StreetAddress.required"
                      >
                        {{ $t("form.validation.required") }}
                      </div>
                    </div>

                    <div class="form-group">
                      <label for="City:">
                        {{ $t("form.student.city") }}
                        <span class="req text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        id="City"
                        v-model.trim="$v.studentBussiness.City.$model"
                        class="form-control"
                        :class="{
                          'is-invalid': $v.studentBussiness.City.$error,
                        }"
                      />
                      <div
                        class="invalid-feedback"
                        v-if="!$v.studentBussiness.City.required"
                      >
                        {{ $t("form.validation.required") }}
                      </div>
                      <div
                        class="invalid-feedback"
                        v-if="!$v.studentBussiness.City.maxLength"
                      >
                        {{
                          $t("form.validation.maxLength", {
                            num: $v.studentBussiness.City.$params.maxLength.max,
                          })
                        }}
                      </div>
                    </div>

                    <div class="form-group">
                      <label class for="Zip:">
                        {{ $t("form.student.zip") }}
                        <span class="req text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        v-model.trim="$v.studentBussiness.Zip.$model"
                        class="form-control"
                        :class="{
                          'is-invalid': $v.studentBussiness.Zip.$error,
                        }"
                      />
                      <div
                        class="invalid-feedback"
                        v-if="!$v.studentBussiness.Zip.required"
                      >
                        {{ $t("form.validation.required") }}
                      </div>
                      <div
                        class="invalid-feedback"
                        v-if="!$v.studentBussiness.Zip.maxLength"
                      >
                        {{
                          $t("form.validation.maxLength", {
                            num: $v.studentBussiness.Zip.$params.maxLength.max,
                          })
                        }}
                      </div>
                    </div>
                    <div class="form-group">
                      <label class for="Country:">
                        {{ $t("form.student.country") }}
                        <span class="req text-danger">*</span>
                      </label>
                      <v-select
                        label="printable_name"
                        :options="countries"
                        v-model.trim="$v.studentBussiness.Country.$model"
                        :reduce="(countries) => countries.printable_name"
                        class="BussinessCountry"
                      >
                      </v-select>
                      <div
                        class="invalid-feedback"
                        v-if="!$v.studentBussiness.Country.required"
                      >
                        {{ $t("form.validation.required") }}
                      </div>
                    </div>
                    <div class="form-group">
                      <label class for="Phone:">
                        {{ $t("form.student.phone") }}
                        <span class="req text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        v-model.trim="$v.studentBussiness.Phone.$model"
                        class="form-control"
                        :class="{
                          'is-invalid': $v.studentBussiness.Phone.$error,
                        }"
                      />
                      <div
                        class="invalid-feedback"
                        v-if="!$v.studentBussiness.Phone.required"
                      >
                        {{ $t("form.validation.required") }}
                      </div>
                      <div
                        class="invalid-feedback"
                        v-if="!$v.studentBussiness.Phone.maxLength"
                      >
                        {{
                          $t("form.validation.maxLength", {
                            num: $v.studentBussiness.Phone.$params.maxLength
                              .max,
                          })
                        }}
                      </div>
                    </div>
                    <div class="form-group">
                      <label class for="Mobile:">
                        {{ $t("form.student.mobile") }}
                        <span class="req text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        v-model.trim="$v.studentBussiness.Mobile.$model"
                        class="form-control"
                        :class="{
                          'is-invalid': $v.studentBussiness.Mobile.$error,
                        }"
                      />
                      <div
                        class="invalid-feedback"
                        v-if="!$v.studentBussiness.Mobile.required"
                      >
                        {{ $t("form.validation.required") }}
                      </div>
                      <div
                        class="invalid-feedback"
                        v-if="!$v.studentBussiness.Mobile.maxLength"
                      >
                        {{
                          $t("form.validation.maxLength", {
                            num: $v.studentBussiness.Mobile.$params.maxLength
                              .max,
                          })
                        }}
                      </div>
                    </div>
                    <div class="form-group">
                      <label class for="Fax:">{{
                        $t("form.student.fax")
                      }}</label>

                      <input
                        id="Fax:"
                        name="Fax"
                        v-model="studentBussiness.Fax"
                        type="text"
                        class="form-control"
                        data-role="text"
                        data-parsley-errors-container="#errId31"
                      />
                      <span id="errId31" class="error"></span>
                    </div>
                    <div class="form-group">
                      <label>
                        {{ $t("form.student.email") }}
                        <span class="req text-danger">*</span>
                      </label>
                      <input
                        type="email"
                        v-model.trim="$v.studentBussiness.Email.$model"
                        class="form-control"
                        :class="{
                          'is-invalid': $v.studentBussiness.Email.$error,
                        }"
                      />
                      <div
                        class="invalid-feedback"
                        v-if="!$v.studentBussiness.Email.required"
                      >
                        {{ $t("form.validation.required") }}
                      </div>
                      <div
                        class="invalid-feedback"
                        v-if="!$v.studentBussiness.Email.email"
                      >
                        {{ $t("form.validation.validEmail") }}
                      </div>
                    </div>
                    <div class="form-group">
                      <label class for="BussinessWebAddress:">
                        {{ $t("form.student.webAddress") }}
                      </label>

                      <input
                        id="BussinessWebAddress:"
                        name="BussinessWebAddress"
                        v-model="studentBussiness.WebAddress"
                        type="text"
                        class="form-control"
                        data-role="text"
                        data-parsley-errors-container="#errId33"
                      />
                    </div>
                    <div class="form-group">
                      <h5>
                        <b>
                          <u>{{ $t("form.student.contactPerson") }}</u>
                        </b>
                      </h5>
                      <p
                        id="field89"
                        data-default-label="Header"
                        data-default-is-header="true"
                        data-control-type="header"
                      ></p>
                    </div>
                    <div class="form-group">
                      <label class for="ContactPersonTitle:">{{
                        $t("form.student.title")
                      }}</label>
                      <v-select
                        :options="titles"
                        v-model="studentBussiness.ContactPersonTitle"
                        :reduce="(titles) => titles"
                      >
                      </v-select>
                    </div>
                    <div class="form-group">
                      <label class for="FirstName:">
                        {{ $t("form.student.firstName") }}
                      </label>

                      <input
                        type="text"
                        id="ContactPersonFirstNameField"
                        v-model.trim="
                          $v.studentBussiness.ContactPersonFirstName.$model
                        "
                        class="form-control"
                        :class="{
                          'is-invalid':
                            $v.studentBussiness.ContactPersonFirstName.$error,
                        }"
                      />

                      <div
                        class="invalid-feedback"
                        v-if="
                          !$v.studentBussiness.ContactPersonFirstName.maxLength
                        "
                      >
                        {{
                          $t("form.validation.maxLength", {
                            num: $v.studentBussiness.ContactPersonFirstName
                              .$params.maxLength.max,
                          })
                        }}
                      </div>
                    </div>
                    <div class="form-group">
                      <label class for="LastName:">
                        {{ $t("form.student.lastName") }}
                      </label>

                      <input
                        type="text"
                        id="ContactPersonLastNameField"
                        v-model.trim="
                          $v.studentBussiness.ContactPersonLastName.$model
                        "
                        class="form-control"
                        :class="{
                          'is-invalid':
                            $v.studentBussiness.ContactPersonLastName.$error,
                        }"
                      />

                      <div
                        class="invalid-feedback"
                        v-if="
                          !$v.studentBussiness.ContactPersonLastName.maxLength
                        "
                      >
                        {{
                          $t("form.validation.maxLength", {
                            num: $v.studentBussiness.ContactPersonLastName
                              .$params.maxLength.max,
                          })
                        }}
                      </div>
                    </div>
                    <div class="form-group">
                      <label class for="ContactPersonDepartment:">
                        {{ $t("form.student.department") }}
                      </label>

                      <input
                        type="text"
                        id="ContactPersonDepartment"
                        v-model.trim="
                          $v.studentBussiness.ContactPersonDepartment.$model
                        "
                        class="form-control"
                        :class="{
                          'is-invalid':
                            $v.studentBussiness.ContactPersonDepartment.$error,
                        }"
                      />

                      <div
                        class="invalid-feedback"
                        v-if="
                          !$v.studentBussiness.ContactPersonDepartment.maxLength
                        "
                      >
                        {{
                          $t("form.validation.maxLength", {
                            num: $v.studentBussiness.ContactPersonDepartment
                              .$params.maxLength.max,
                          })
                        }}
                      </div>
                    </div>
                  </div>

                  <div class="col-sm-8" v-else>
                    <div class="form-group">
                      <label for="CompanyName:">
                        {{ $t("form.student.companyName") }}
                      </label>
                      <input
                        id="CompanyName"
                        type="text"
                        v-model.trim="studentBussiness.CompanyName"
                        name="CompanyName"
                        class="form-control"
                      />
                    </div>
                    <div class="form-group">
                      <label class for="BusinessDepartment">
                        {{ $t("form.student.department") }}
                      </label>
                      <input
                        type="text"
                        id="BusinessDepartment"
                        v-model.trim="studentBussiness.Department"
                        class="form-control"
                      />
                    </div>
                    <div class="form-group">
                      <label class for="BusinessPosition:">
                        {{ $t("form.student.position") }}
                      </label>

                      <input
                        id="BusinessPosition:"
                        name="BusinessPosition"
                        v-model.trim="studentBussiness.Position"
                        class="form-control"
                      />
                    </div>
                    <div class="form-group">
                      <label class for="StreetAddress:">
                        {{ $t("form.student.streetAddress") }}
                      </label>
                      <input
                        type="text"
                        v-model.trim="studentBussiness.StreetAddress"
                        class="form-control"
                      />
                    </div>

                    <div class="form-group">
                      <label for="City:">
                        {{ $t("form.student.city") }}
                      </label>
                      <input
                        type="text"
                        id="City"
                        v-model.trim="studentBussiness.City"
                        class="form-control"
                      />
                    </div>

                    <div class="form-group">
                      <label class for="Zip:">
                        {{ $t("form.student.zip") }}
                      </label>
                      <input
                        type="text"
                        v-model.trim="studentBussiness.Zip"
                        class="form-control"
                      />
                    </div>
                    <div class="form-group">
                      <label class for="Country:">
                        {{ $t("form.student.country") }}
                      </label>
                      <v-select
                        label="printable_name"
                        :options="countries"
                        v-model.trim="studentBussiness.Country"
                        :reduce="(countries) => countries.printable_name"
                        class="BussinessCountry"
                      >
                      </v-select>
                    </div>
                    <div class="form-group">
                      <label class for="Phone:">
                        {{ $t("form.student.phone") }}
                      </label>
                      <input
                        type="text"
                        v-model.trim="studentBussiness.Phone"
                        class="form-control"
                      />
                    </div>
                    <div class="form-group">
                      <label class for="Mobile:">
                        {{ $t("form.student.mobile") }}
                      </label>
                      <input
                        type="text"
                        v-model.trim="studentBussiness.Mobile"
                        class="form-control"
                      />
                    </div>
                    <div class="form-group">
                      <label class for="Fax:">{{
                        $t("form.student.fax")
                      }}</label>

                      <input
                        id="Fax:"
                        name="Fax"
                        v-model="studentBussiness.Fax"
                        type="text"
                        class="form-control"
                        data-role="text"
                        data-parsley-errors-container="#errId31"
                      />
                      <span id="errId31" class="error"></span>
                    </div>
                    <div class="form-group">
                      <label>
                        {{ $t("form.student.email") }}
                      </label>
                      <input
                        type="email"
                        v-model.trim="studentBussiness.Email"
                        class="form-control"
                      />
                    </div>
                    <div class="form-group">
                      <label class for="BussinessWebAddress:">
                        {{ $t("form.student.webAddress") }}
                      </label>

                      <input
                        id="BussinessWebAddress:"
                        name="BussinessWebAddress"
                        v-model="studentBussiness.WebAddress"
                        type="text"
                        class="form-control"
                        data-role="text"
                        data-parsley-errors-container="#errId33"
                      />
                    </div>
                    <div class="form-group">
                      <h5>
                        <b>
                          <u>{{ $t("form.student.contactPerson") }}</u>
                        </b>
                      </h5>
                      <p
                        id="field89"
                        data-default-label="Header"
                        data-default-is-header="true"
                        data-control-type="header"
                      ></p>
                    </div>
                    <div class="form-group">
                      <label class for="ContactPersonTitle:">{{
                        $t("form.student.title")
                      }}</label>
                      <v-select
                        :options="titles"
                        v-model="studentBussiness.ContactPersonTitle"
                        :reduce="(titles) => titles"
                      >
                      </v-select>
                    </div>
                    <div class="form-group">
                      <label class for="FirstName:">
                        {{ $t("form.student.firstName") }}
                      </label>

                      <input
                        type="text"
                        id="ContactPersonFirstNameField"
                        v-model.trim="studentBussiness.ContactPersonFirstName"
                        class="form-control"
                      />
                    </div>
                    <div class="form-group">
                      <label class for="LastName:">
                        {{ $t("form.student.lastName") }}
                      </label>

                      <input
                        type="text"
                        id="ContactPersonLastNameField"
                        v-model.trim="studentBussiness.ContactPersonLastName"
                        class="form-control"
                      />
                    </div>
                    <div class="form-group">
                      <label class for="ContactPersonDepartment:">
                        {{ $t("form.student.department") }}
                      </label>

                      <input
                        type="text"
                        id="ContactPersonDepartment"
                        v-model.trim="studentBussiness.ContactPersonDepartment"
                        class="form-control"
                      />
                    </div>
                  </div>

                  <div class="col-md-4">
                    <div class="form-group">
                      <label class for="Notes:">{{
                        $t("form.student.notes")
                      }}</label>
                      <textarea
                        id="Notes:"
                        name="Notes"
                        v-model="studentBussiness.Notes"
                        rows="15"
                        class="form-control"
                        data-role="textarea"
                        data-parsley-errors-container="#errId39"
                      ></textarea>
                      <span id="errId39" class="error"></span>
                    </div>
                  </div>
                </div>
              </b-tab>

              <b-tab :title="$t('form.student.tabRemarks')">
                <div class="form-group">
                  <div class="mb-3">
                    <label>{{ $t("form.student.remarks") }}</label>
                    <!-- <b-button @click="downloadRemarks" class="float-right">
                                            {{$t('button.exportPDF')}}</b-button> -->
                  </div>
                  <summernote v-model="student.Remarks"></summernote>
                  <p class="text-muted">
                    {{ $t("form.student.remarksExportNote") }}
                  </p>
                </div>
              </b-tab>

              <b-tab :title="$t('form.student.tabAdmission')">
                <div class="row">
                  <div class="col-md-5">
                    <div class="form-group">
                      <label for="EducationalBackground:">{{
                        $t("form.student.background")
                      }}</label>
                      <div class>
                        <textarea
                          id="educationalbackground:"
                          name="educationalbackground"
                          v-model="studentAdmission.EducationalBackground"
                          rows="15"
                          class="form-control"
                          data-role="textarea"
                          data-parsley-errors-container="#errId40"
                        ></textarea>
                        <span id="errId40" class="error"></span>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-7">
                    <label>{{ $t("form.student.bachelorAdmission") }}</label>
                    <div class="row">
                      <div class="col-6">
                        <label class="checkbox" for="checkbox141">
                          <input
                            type="checkbox"
                            name="ExamAdmBBA"
                            v-model="studentAdmission.ExamAdmBBA"
                            id="checkbox141"
                            data-parsley-errors-container="#errId41"
                            @change="changeCheck($event)"
                            value="0"
                          />
                          {{ $t("form.student.admissionOption1") }}
                        </label>
                      </div>

                      <div class="col-6">
                        <div class="form-group">
                          <div class>
                            <input
                              id="ExamAdmResultBBA"
                              type="text"
                              class="form-control"
                              data-role="text"
                              data-parsley-errors-container="#errId42"
                              name="ExamAdmResultBBA"
                              v-model="studentAdmission.ExamAdmResultBBA"
                              :placeholder="$t('form.student.result')"
                            />
                            <span id="errId42" class="error"></span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-6">
                        <label class="checkbox" for="checkbox143">
                          <input
                            type="checkbox"
                            id="checkbox143"
                            name="ExamOthBBA"
                            v-model="studentAdmission.ExamOthBBA"
                            data-parsley-errors-container="#errId41"
                            @change="changeCheck($event)"
                            value="0"
                          />
                          {{ $t("form.student.admissionOption3") }}
                        </label>
                      </div>

                      <div class="col-6">
                        <div class="form-group">
                          <div class>
                            <input
                              id="result_other_b"
                              type="text"
                              name="ExamOthResultBBA"
                              v-model="studentAdmission.ExamOthResultBBA"
                              class="form-control k-textbox"
                              data-role="text"
                              data-parsley-errors-container="#errId44"
                              :placeholder="$t('form.student.result')"
                            />
                            <span id="errId44" class="error"></span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <label>{{ $t("form.student.masterAdmission") }}</label>
                    <div class="row">
                      <div class="col-6">
                        <label class="checkbox" for="checkbox149">
                          <input
                            @change="changeCheck($event)"
                            value="0"
                            type="checkbox"
                            name="ExamAdmMAS"
                            id="checkbox149"
                            v-model="studentAdmission.ExamAdmMAS"
                            data-parsley-errors-container="#errId45"
                          />
                          {{ $t("form.student.admissionOption1") }}
                        </label>
                      </div>
                      <div class="col-6">
                        <div class="form-group">
                          <div class>
                            <input
                              id="result_entrance_m"
                              type="text"
                              class="form-control"
                              data-role="text"
                              data-parsley-errors-container="#errId46"
                              name="ExamAdmResultMAS"
                              v-model="studentAdmission.ExamAdmResultMAS"
                              :placeholder="$t('form.student.result')"
                            />
                            <span id="errId46" class="error"></span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-6">
                        <label class="checkbox" for="ExamEntMAS">
                          <input
                            type="checkbox"
                            @change="changeCheck($event)"
                            value="0"
                            name="ExamEntMAS"
                            id="ExamEntMAS"
                            v-model="studentAdmission.ExamEntMAS"
                            data-parsley-errors-container="#errId45"
                          />
                          {{ $t("form.student.admissionOption2") }}
                        </label>
                      </div>
                      <div class="col-6">
                        <div class="form-group">
                          <div class>
                            <input
                              id="result_admission_m"
                              name="ExamEntResultMAS"
                              v-model="studentAdmission.ExamEntResultMAS"
                              type="text"
                              class="form-control"
                              data-role="text"
                              data-parsley-errors-container="#errId47"
                              :placeholder="$t('form.student.result')"
                            />
                            <span id="errId47" class="error"></span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-6">
                        <label class="checkbox" for="ExamOthMAS">
                          <input
                            @change="changeCheck($event)"
                            value="0"
                            type="checkbox"
                            id="ExamOthMAS"
                            name="ExamOthMAS"
                            v-model="studentAdmission.ExamOthMAS"
                            data-parsley-errors-container="#errId45"
                          />
                          {{ $t("form.student.admissionOption3") }}
                        </label>
                      </div>
                      <div class="col-6">
                        <div class="form-group">
                          <div class>
                            <input
                              id="ExamOthResultMAS"
                              type="text"
                              name="ExamOthResultMAS"
                              v-model="studentAdmission.ExamOthResultMAS"
                              class="form-control"
                              data-role="text"
                              data-parsley-errors-container="#errId48"
                              :placeholder="$t('form.student.result')"
                            />
                            <span id="errId48" class="error"></span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <label>{{ $t("form.student.doctorateAdmission") }}</label>
                    <div class="row">
                      <div class="col-6">
                        <label class="checkbox" for="ExamEntDBA">
                          <input
                            type="checkbox"
                            @change="changeCheck($event)"
                            value="0"
                            v-model="studentAdmission.ExamEntDBA"
                            id="ExamEntDBA"
                            name="ExamEntDBA"
                            data-parsley-errors-container="#errId49"
                          />
                          {{ $t("form.student.admissionOption2") }}
                        </label>
                      </div>
                      <div class="col-6">
                        <div class="form-group">
                          <div class>
                            <input
                              id="ExamEntResultDBA"
                              name="ExamEntResultDBA"
                              v-model="studentAdmission.ExamEntResultDBA"
                              type="text"
                              class="form-control"
                              data-role="text"
                              data-parsley-errors-container="#errId50"
                              :placeholder="$t('form.student.result')"
                            />
                            <span id="errId50" class="error"></span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-6">
                        <label class="checkbox" for="ExamOthDBA">
                          <input
                            type="checkbox"
                            @change="changeCheck($event)"
                            value="0"
                            v-model="studentAdmission.ExamOthDBA"
                            id="ExamOthDBA"
                            name="ExamOthDBA"
                            data-parsley-errors-container="#errId49"
                          />
                          {{ $t("form.student.admissionOption3") }}
                        </label>
                      </div>
                      <div class="col-6">
                        <div class="form-group">
                          <div class>
                            <input
                              id="ExamOthResultDBA"
                              name="ExamOthResultDBA"
                              v-model="studentAdmission.ExamOthResultDBA"
                              type="text"
                              class="form-control k-textbox"
                              data-role="text"
                              data-parsley-errors-container="#errId51"
                              :placeholder="$t('form.student.result')"
                            />
                            <span id="errId51" class="error"></span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </b-tab>

              <b-tab :title="$t('form.student.tabProgram')">
                <div class="row">
                  <div class="col-md-12">
                    <div class="form-group">
                      <label class for="Program">{{
                        $t("form.student.program")
                      }}</label>
                      <span class="text-danger">*</span>
                      <div class>
                        <v-select
                          @input="selectProgram"
                          label="FullTitle"
                          :options="programs"
                          v-model="studentProgram.ProgramID"
                          :reduce="(programs) => programs.ID"
                        >
                        </v-select>
                      </div>
                    </div>

                    <div class="form-group">
                      <label for="SecondrayMajor">
                        {{ $t("form.student.program2") }}
                      </label>
                      <div v-if="secondaryPrograms.length">
                        <v-select
                          label="FullTitle"
                          :options="secondaryPrograms"
                          @input="selectProgram2"
                          v-model="studentProgram.Program2ID"
                          :reduce="(secondaryPrograms) => secondaryPrograms.ID"
                          :resetOnOptionsChange="true"
                        >
                        </v-select>
                      </div>
                      <div v-else>
                        <select class="form-control" disabled>
                          <option value=""></option>
                        </select>
                      </div>
                    </div>

                    <div class="form-group">
                      <label class="checkbox">
                        <input
                          type="checkbox"
                          @change="changeCheck($event)"
                          value="0"
                          v-model="studentProgram.BooksIncluded"
                        />
                        {{ $t("form.student.books") }}
                      </label>
                      <br />
                      <label class="checkbox">
                        <input
                          type="checkbox"
                          @change="changeCheck($event)"
                          :checked="studentProgram.Graduate"
                          :disabled="studentProgram.Graduate"
                        />
                        {{ $t("form.student.graduate") }}
                      </label>
                      <br />
                      <label class="checkbox">
                        <input
                          type="checkbox"
                          @change="changeCheck($event)"
                          value="0"
                          v-model="studentProgram.Withdraw"
                        />
                        {{ $t("form.student.withdrawn") }}
                      </label>
                    </div>

                    <div class="form-group">
                      <label for="ThesisSubject">{{
                        $t("form.student.thesisSubject")
                      }}</label>
                      <div class>
                        <textarea
                          id="ThesisSubject"
                          v-model.trim="$v.studentProgram.ThesisSubject.$model"
                          name="ThesisSubject"
                          rows="3"
                          class="form-control k-textbox"
                          data-role="textarea"
                          :class="{
                            'is-invalid':
                              $v.studentProgram.ThesisSubject.$error,
                          }"
                        ></textarea>
                        <div
                          class="invalid-feedback"
                          v-if="!$v.studentProgram.ThesisSubject.maxLength"
                        >
                          {{
                            $t("form.validation.maxLength", {
                              num: $v.studentProgram.ThesisSubject.$params
                                .maxLength.max,
                            })
                          }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-6">
                    <label for="DefenceExaminer">{{
                      $t("form.student.defenceExaminer")
                    }}</label>
                    <div class="form-group">
                      <label
                        class="control-label control-label-left col-3 sr-only"
                      ></label>
                      <v-select
                        label="fullName"
                        :options="professor"
                        v-model="studentProgram.Examiner1"
                        :reduce="(professor) => professor.ID"
                        :key="studentProgram.Examiner1"
                      >
                      </v-select>
                    </div>
                    <div class="form-group">
                      <label class="sr-only"></label>
                      <v-select
                        label="fullName"
                        :options="professor"
                        v-model="studentProgram.Examiner2"
                        :reduce="(professor) => professor.ID"
                        :key="studentProgram.Examiner2"
                      >
                      </v-select>
                    </div>
                    <div class="form-group">
                      <label class="sr-only"></label>
                      <v-select
                        label="fullName"
                        :options="professor"
                        v-model="studentProgram.Examiner3"
                        :key="studentProgram.Examiner3"
                        :reduce="(professor) => professor.ID"
                      >
                      </v-select>
                    </div>

                    <div class="form-group">
                      <label class="sr-only"></label>
                      <v-select
                        label="fullName"
                        :options="professor"
                        v-model="studentProgram.Examiner4"
                        :key="studentProgram.Examiner4"
                        :reduce="(professor) => professor.ID"
                      >
                      </v-select>
                    </div>
                    <div class="form-group">
                      <label class="sr-only"></label>
                      <v-select
                        label="fullName"
                        :options="professor"
                        v-model="studentProgram.Examiner5"
                        :key="studentProgram.Examiner5"
                        :reduce="(professor) => professor.ID"
                      >
                      </v-select>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="GraduationDate">
                        {{ $t("form.student.graduateDate") }}
                      </label>
                      <div class>
                        <date-picker
                          class="date-picker"
                          :lang="lang"
                          v-model="studentProgram.GraduationDate"
                          valueType="format"
                          :format="dateFormat"
                          :append-to-body="true"
                          :placeholder="studentProgram.GraduationDate"
                        >
                        </date-picker>
                        <span id="errId60" class="error"></span>
                      </div>
                    </div>

                    <div class="form-group">
                      <label class for="ThesisPercentage">{{
                        $t("form.student.thesisPercentage")
                      }}</label>
                      <div class>
                        <input
                          id="ThesisPercentage"
                          name="ThesisPercentage"
                          type="number"
                          class="form-control"
                          readonly
                        />
                      </div>
                    </div>
                    <div class="form-group">
                      <label for="ThesisGrade">{{
                        $t("form.student.thesisGrade")
                      }}</label>
                      <div class>
                        <input
                          id="ThesisGrade"
                          name="ThesisGrade"
                          type="text"
                          class="form-control"
                          readonly
                        />
                      </div>
                    </div>
                    <div class="form-group">
                      <label for="ThesisMentor">{{
                        $t("form.student.thesisMentor")
                      }}</label>
                      <v-select
                        label="fullName"
                        :options="professor"
                        v-model="studentProgram.ThesisMentor"
                        :key="studentProgram.ThesisMentor"
                        :reduce="(professor) => professor.ID"
                      >
                      </v-select>
                    </div>
                  </div>
                </div>
              </b-tab>

              <b-tab :title="$t('form.student.tabGrade')" ref="gradesTab">
                <div class="row">
                  <div class="col-md-9">
                    <b-alert :show="noGradingScale" variant="light">
                      <div v-html="noGradingScale"></div>
                    </b-alert>
                    <div class="table-responsive">
                      <table class="table table-bordered table-hover">
                        <thead>
                          <tr>
                            <th>{{ $t("form.student.course") }}</th>
                            <th>{{ $t("form.student.percentage") }}</th>
                            <th style="min-width: 90px">
                              {{ $t("form.student.grade") }}
                            </th>
                            <th>{{ $t("form.student.descGrade") }}</th>
                            <!-- <th style="min-width: 90px;">
                                                            {{$t('form.student.ectsGrade')}}</th> -->
                            <th>{{ $t("form.student.finalExam") }}</th>
                            <th>{{ $t("form.student.enroll") }}</th>
                            <th>{{ $t("form.student.deductibleCredits") }}</th>
                            <th>{{ $t("form.student.action") }}</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-if="secondaryGrades.length"
                            class="bg-light text-center"
                          >
                            <td colspan="8">
                              <h5>{{ $t("form.student.primaryGrades") }}</h5>
                            </td>
                          </tr>
                          <tr
                            v-for="(line, index) in $v.grades.$each.$iter"
                            v-bind:key="index"
                          >
                            <td>{{ grades[index].FullTitle }}</td>
                            <td>
                              <div class="form-group">
                                <input
                                  @keyup="applyGradingScale(grades[index])"
                                  type="text"
                                  class="form-control"
                                  v-model.trim="line.Percentage.$model"
                                  :class="{
                                    'is-invalid': line.Percentage.$error,
                                  }"
                                />
                                <div
                                  class="invalid-feedback"
                                  v-if="!line.Percentage.between"
                                >
                                  {{
                                    $t("form.validation.between", {
                                      num1: line.Percentage.$params.between.min,
                                      num2: line.Percentage.$params.between.max,
                                    })
                                  }}
                                </div>
                              </div>
                            </td>
                            <td>
                              <div class="form-group">
                                <input
                                  type="text"
                                  class="form-control"
                                  v-model.trim="line.Grade.$model"
                                  :class="{ 'is-invalid': line.Grade.$error }"
                                />
                                <div
                                  class="invalid-feedback"
                                  v-if="!line.Grade.between"
                                >
                                  {{
                                    $t("form.validation.between", {
                                      num1: line.Grade.$params.between.min,
                                      num2: line.Grade.$params.between.max,
                                    })
                                  }}
                                </div>
                              </div>
                            </td>
                            <td>
                              <select
                                v-model="grades[index].DescriptiveGrade"
                                class="form-control"
                              >
                                <option
                                  v-for="(
                                    descriptiveGrade, index
                                  ) in descriptiveGrades"
                                  v-bind:key="index"
                                  :value="descriptiveGrade"
                                >
                                  {{ descriptiveGrade }}
                                </option>
                              </select>
                              <!-- <v-select :options="descriptiveGrades"
                                                                v-model="grades[index].DescriptiveGrade"
                                                                :key="grades[index].DescriptiveGrade"
                                                                :reduce="descriptiveGrades => descriptiveGrades">
                                                            </v-select> -->
                            </td>
                            <!-- <td>
                                                            <select v-model="grades[index].ECTSGrade"
                                                                class="form-control">
                                                                <option v-for="(ECTSGrade , index) in ECTSGrades"
                                                                    v-bind:key="index" :value="ECTSGrade">{{ECTSGrade}}
                                                                </option>
                                                            </select>
                                                            <v-select :options="ECTSGrades"
                                                                v-model="grades[index].ECTSGrade"
                                                                :key="grades[index].ECTSGrade"
                                                                :reduce="ECTSGrades => ECTSGrades">
                                                            </v-select>
                                                        </td> -->
                            <td>
                              <date-picker
                                class="date-picker"
                                :lang="lang"
                                v-model="grades[index].FinalExameDate"
                                valueType="format"
                                :format="dateFormat"
                                :popup-style="{ top: '100%', left: 0 }"
                                :append-to-body="false"
                              >
                              </date-picker>
                              <!-- <input type="date" class="form-control"
                                                                v-model="grades[index].FinalExameDate"> -->
                            </td>
                            <td>
                              <input
                                type="checkbox"
                                v-model="grades[index].Enrolled"
                                @change="changeCheck($event)"
                                value="0"
                              />
                            </td>
                            <td>
                              <input
                                type="checkbox"
                                v-model="grades[index].deductibleCredits"
                                @change="changeCreditCheck($event)"
                              />
                            </td>
                            <td>
                              <a
                                class="btn btn-danger btn-sm text-white"
                                @click="removeGrade(index)"
                              >
                                <i class="fa fa-times" aria-hidden="true"></i>
                              </a>
                            </td>
                          </tr>
                        </tbody>
                        <tbody>
                          <tr
                            v-if="secondaryGrades.length"
                            class="bg-light text-center"
                          >
                            <td colspan="8">
                              <h5>{{ $t("form.student.secondaryGrades") }}</h5>
                            </td>
                          </tr>
                          <tr
                            v-for="(line, index) in $v.secondaryGrades.$each
                              .$iter"
                            v-bind:key="index"
                          >
                            <td>{{ secondaryGrades[index].FullTitle }}</td>
                            <td>
                              <div class="form-group">
                                <input
                                  @keyup="
                                    applyGradingScale(
                                      secondaryGrades[index],
                                      'se'
                                    )
                                  "
                                  type="text"
                                  class="form-control"
                                  v-model.trim="line.Percentage.$model"
                                  :class="{
                                    'is-invalid': line.Percentage.$error,
                                  }"
                                />
                                <div
                                  class="invalid-feedback"
                                  v-if="!line.Percentage.between"
                                >
                                  {{
                                    $t("form.validation.between", {
                                      num1: line.Percentage.$params.between.min,
                                      num2: line.Percentage.$params.between.max,
                                    })
                                  }}
                                </div>
                              </div>
                            </td>
                            <td>
                              <div class="form-group">
                                <input
                                  type="text"
                                  class="form-control"
                                  v-model.trim="line.Grade.$model"
                                  :class="{ 'is-invalid': line.Grade.$error }"
                                />
                                <div
                                  class="invalid-feedback"
                                  v-if="!line.Grade.between"
                                >
                                  {{
                                    $t("form.validation.between", {
                                      num1: line.Grade.$params.between.min,
                                      num2: line.Grade.$params.between.max,
                                    })
                                  }}
                                </div>
                              </div>
                            </td>
                            <td>
                              <select
                                v-model="
                                  secondaryGrades[index].DescriptiveGrade
                                "
                                class="form-control"
                              >
                                <option
                                  v-for="(
                                    descriptiveGrade, index
                                  ) in descriptiveGrades"
                                  v-bind:key="index"
                                  :value="descriptiveGrade"
                                >
                                  {{ descriptiveGrade }}
                                </option>
                              </select>
                              <!-- <v-select :options="descriptiveGrades"
                                                                v-model="secondaryGrades[index].DescriptiveGrade"
                                                                :key="secondaryGrades[index].DescriptiveGrade"
                                                                :reduce="descriptiveGrades => descriptiveGrades">
                                                            </v-select> -->
                            </td>
                            <!-- <td>
                                                            <select v-model="secondaryGrades[index].ECTSGrade"
                                                                class="form-control">
                                                                <option v-for="(ECTSGrade , index) in ECTSGrades"
                                                                    v-bind:key="index" :value="ECTSGrade">{{ECTSGrade}}
                                                                </option>
                                                            </select>
                                                            <v-select :options="ECTSGrades"
                                                                v-model="secondaryGrades[index].ECTSGrade"
                                                                :key="secondaryGrades[index].ECTSGrade"
                                                                :reduce="ECTSGrades => ECTSGrades">
                                                            </v-select>
                                                        </td> -->
                            <td>
                              <date-picker
                                class="date-picker"
                                :lang="lang"
                                v-model="secondaryGrades[index].FinalExameDate"
                                valueType="format"
                                :format="dateFormat"
                                :popup-style="{ top: '100%', left: 0 }"
                                :append-to-body="false"
                              >
                              </date-picker>
                              <!-- <input type="date" class="form-control"
                                                                v-model="secondaryGrades[index].FinalExameDate"> -->
                            </td>
                            <td>
                              <input
                                type="checkbox"
                                v-model="secondaryGrades[index].Enrolled"
                                @change="changeCheck($event)"
                                value="0"
                              />
                            </td>
                            <td class="text-center">-</td>
                            <td>
                              <a
                                class="btn btn-danger btn-sm text-white"
                                @click="removeSecondaryGrade(index)"
                              >
                                <i class="fa fa-times" aria-hidden="true"></i>
                              </a>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <div class="col-md-3">
                    <div class="form-group grades-btns" v-if="showGradesBtns">
                      <b-button
                        class="mb-3"
                        variant="default"
                        @click="editProgram()"
                        v-if="permissions.editPrograms"
                      >
                        {{ $t("button.manageProgram") }}</b-button
                      ><br />
                      <b-button
                        variant="default"
                        @click="addProgramCourses()"
                        v-if="permissions.editStudentsGrades"
                      >
                        {{ $t("button.addProgramCourses") }}</b-button
                      >
                    </div>
                    <div class="form-group">
                      <label>{{ $t("form.student.courseSearch") }}</label>
                      <v-select
                        v-if="gradeType == 'pr'"
                        @input="addGrade"
                        label="FullTitle"
                        :options="courses"
                        :reduce="(courses) => courses"
                        :resetOnOptionsChange="true"
                      >
                      </v-select>
                      <v-select
                        v-if="gradeType == 'se'"
                        @input="addGrade"
                        label="FullTitle"
                        :options="courses2"
                        :reduce="(courses2) => courses2"
                        :resetOnOptionsChange="true"
                      >
                      </v-select>
                    </div>
                    <div class="form-group" v-if="studentProgram.Program2ID">
                      <label class="radio-inline">
                        <input type="radio" v-model="gradeType" value="pr" />
                        {{ $t("form.student.primaryGrades") }} </label
                      ><br />
                      <label class="radio-inline">
                        <input type="radio" v-model="gradeType" value="se" />
                        {{ $t("form.student.secondaryGrades") }}
                      </label>
                    </div>
                  </div>
                </div>
              </b-tab>

              <b-tab :title="$t('form.student.tabGraduation')">
                <div class="row">
                  <div class="col-md-4">
                    <h5>
                      <u>
                        <b>{{ $t("form.student.bachelorProgram") }}</b>
                      </u>
                    </h5>

                    <br />

                    <div class="pl-3">
                      <div class="form-group mb-0">
                        <div>
                          <label>
                            <input
                              type="checkbox"
                              name="BBAExitSurvey"
                              v-model="studentGraduateReq.BBAExitSurvey"
                              value="1"
                              @change="changeCheck($event)"
                            />
                            {{ $t("form.student.bachelorProgramOption1") }}
                          </label>
                        </div>
                      </div>
                      <!-- <div class="form-group" v-if="studentGraduateReq.BBAExitSurvey">
                                                <div class>
                                                    <input type="text" class="form-control"
                                                        v-model="studentGraduateReq.BBAExitSurveyResult"
                                                        :placeholder="$t('form.student.programScore')">
                                                </div>
                                            </div> -->
                      <div class="form-group">
                        <div class="checkbox">
                          <label>
                            <input
                              value="1"
                              @change="changeCheck($event)"
                              type="checkbox"
                              name="BBAExitSurveyCBE"
                              v-model="studentGraduateReq.BBAExitSurveyCBE"
                            />
                            {{ $t("form.student.bachelorProgramOption2") }}
                          </label>
                        </div>
                      </div>
                    </div>

                    <div class="form-group">
                      <h5>
                        <u>
                          <b>{{ $t("form.student.masterProgram") }}</b>
                        </u>
                      </h5>
                      <br />
                      <div class="pl-3">
                        <div class="checkbox">
                          <label>
                            <input
                              value="1"
                              @change="changeCheck($event)"
                              type="checkbox"
                              name="MASExitSurvey"
                              v-model="studentGraduateReq.MASExitSurvey"
                            />
                            {{ $t("form.student.masterProgramOption1") }}
                          </label>
                        </div>
                        <div class="form-group mb-0">
                          <div class="checkbox">
                            <label>
                              <input
                                value="1"
                                @change="changeCheck($event)"
                                type="checkbox"
                                name="MSCInternReport"
                                v-model="studentGraduateReq.MSCInternReport"
                              />
                              {{ $t("form.student.masterProgramOption4") }}
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="form-group">
                      <h5>
                        <u>
                          <b>{{ $t("form.student.continuingEducation") }}</b>
                        </u>
                      </h5>
                      <br />
                      <div class="pl-3">
                        <div class="checkbox">
                          <label>
                            <input
                              value="1"
                              @change="changeCheck($event)"
                              type="checkbox"
                              name="DBAExitSurvey"
                              v-model="studentGraduateReq.CEExitSurvey"
                            />
                            {{ $t("form.student.doctorateProgramOption1") }}
                          </label>
                        </div>
                        <div class="form-group mb-0">
                          <div class="checkbox">
                            <label>
                              <input
                                value="1"
                                @change="
                                  changeCheck($event);
                                  clearExamScore();
                                "
                                type="checkbox"
                                name="MASExitExamSBS"
                                v-model="studentGraduateReq.MASExitExamSBS"
                              />
                              {{ $t("form.student.masterProgramOption2") }}
                            </label>
                          </div>

                          <div
                            class="form-group"
                            v-if="studentGraduateReq.MASExitExamSBS"
                          >
                            <div class>
                              <input
                                type="text"
                                class="form-control"
                                v-model="
                                  studentGraduateReq.MASExitExamSBSResult
                                "
                                :placeholder="$t('form.student.programScore')"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="form-group">
                      <h5>
                        <u>
                          <b>{{ $t("form.student.doctorateProgram") }}</b>
                        </u>
                      </h5>
                      <br />
                      <div class="pl-3">
                        <div class="checkbox">
                          <label>
                            <input
                              value="1"
                              @change="changeCheck($event)"
                              type="checkbox"
                              name="DBAExitSurvey"
                              v-model="studentGraduateReq.DBAExitSurvey"
                            />
                            {{ $t("form.student.doctorateProgramOption1") }}
                          </label>
                        </div>

                        <div class="form-group mb-0">
                          <div class="checkbox">
                            <label>
                              <input
                                value="1"
                                @change="
                                  changeCheck($event);
                                  clearExamScore();
                                "
                                type="checkbox"
                                name="DBAExitExamSBS"
                                v-model="studentGraduateReq.DBAExitExamSBS"
                              />
                              {{ $t("form.student.doctorateProgramOption2") }}
                            </label>
                          </div>
                          <div
                            class="form-group"
                            v-if="studentGraduateReq.DBAExitExamSBS"
                          >
                            <div class>
                              <input
                                type="text"
                                class="form-control"
                                v-model="
                                  studentGraduateReq.DBAExitExamSBSResult
                                "
                                :placeholder="$t('form.student.programScore')"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="form-group">
                        <h5>
                          <u>
                            <b>{{ $t("form.student.allPrograms") }}</b>
                          </u>
                        </h5>
                        <br />

                        <div class="pl-3">
                          <div class="checkbox">
                            <label>
                              <input
                                value="1"
                                @change="changeCheck($event)"
                                type="checkbox"
                                name="PassingGPA"
                                v-model="studentGraduateReq.PassingGPA"
                              />
                              {{ $t("form.student.allProgramsOption1") }}
                            </label>
                          </div>

                          <div class="form-group">
                            <div class="checkbox">
                              <label>
                                <input
                                  value="1"
                                  @change="changeCheck($event)"
                                  type="checkbox"
                                  name="FinancialObligations"
                                  v-model="
                                    studentGraduateReq.FinancialObligations
                                  "
                                />
                                {{ $t("form.student.allProgramsOption2") }}
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-8" v-if="selectedProgramCode == 'DBA'">
                    <h5>
                      <u>
                        <b>{{ $t("form.student.dba") }}</b>
                      </u>
                    </h5>

                    <br />

                    <div class="pl-3">
                      <div class="form-group row">
                        <label class="col-md-4">{{
                          $t("form.student.ethicsApprovalDoc")
                        }}</label>
                        <input
                          type="text"
                          class="col-md-7 form-control"
                          v-model="studentGraduateReq.DBAEthicsApprovalDoc"
                        />
                      </div>

                      <div class="form-group row">
                        <label class="col-md-4">{{
                          $t("form.student.approvedDate")
                        }}</label>
                        <!-- <input type="text" class="col-md-7 form-control"
                                                    v-model="studentGraduateReq.DBAEApprovalDate"> -->
                        <div class="col-md-7 p-0">
                          <date-picker
                            class="date-picker"
                            :lang="lang"
                            v-model="studentGraduateReq.DBAEApprovalDate"
                            valueType="format"
                            :format="dateFormat"
                            :popup-style="{ top: '100%', left: 0 }"
                            :append-to-body="false"
                          >
                          </date-picker>
                        </div>
                      </div>

                      <div class="form-group row">
                        <label class="col-md-4">{{
                          $t("form.student.statisticsExamDate")
                        }}</label>
                        <!-- <input type="text" class="col-md-7 form-control"
                                                    v-model="studentGraduateReq.DBAStatsExamDate"> -->
                        <div class="col-md-7 p-0">
                          <date-picker
                            class="date-picker"
                            :lang="lang"
                            v-model="studentGraduateReq.DBAStatsExamDate"
                            valueType="format"
                            :format="dateFormat"
                            :popup-style="{ top: '100%', left: 0 }"
                            :append-to-body="false"
                          >
                          </date-picker>
                        </div>
                      </div>

                      <div class="form-group row">
                        <label class="col-md-4">{{
                          $t("form.student.statisticsExamResult")
                        }}</label>
                        <input
                          type="text"
                          class="col-md-7 form-control"
                          v-model="studentGraduateReq.DBAStatsExamResult"
                        />
                      </div>

                      <div class="form-group row">
                        <label class="col-md-4">{{
                          $t("form.student.compsDate")
                        }}</label>
                        <!-- <input type="text" class="col-md-7 form-control"
                                                    v-model="studentGraduateReq.DBACompsDate"> -->

                        <div class="col-md-7 p-0">
                          <date-picker
                            class="date-picker"
                            :lang="lang"
                            v-model="studentGraduateReq.DBACompsDate"
                            valueType="format"
                            :format="dateFormat"
                            :popup-style="{ top: '100%', left: 0 }"
                            :append-to-body="false"
                          >
                          </date-picker>
                        </div>
                      </div>

                      <div class="form-group row">
                        <label class="col-md-4">{{
                          $t("form.student.compsResult")
                        }}</label>
                        <input
                          type="text"
                          class="col-md-7 form-control"
                          v-model="studentGraduateReq.DBACompsResult"
                        />
                      </div>

                      <div class="form-group">
                        <label>
                          <input
                            type="checkbox"
                            name="DBAMAIssued"
                            v-model="studentGraduateReq.DBAMAIssued"
                            @change="changeCheck($event)"
                          />
                          {{ $t("form.student.maIssued") }}
                        </label>
                      </div>

                      <div class="form-group row">
                        <label class="col-md-4">{{
                          $t("form.student.maDate")
                        }}</label>
                        <!-- <input type="text" class="col-md-7 form-control"
                                                    v-model="studentGraduateReq.DBAMADate"> -->
                        <div class="col-md-7 p-0">
                          <date-picker
                            class="date-picker"
                            :lang="lang"
                            v-model="studentGraduateReq.DBAMADate"
                            valueType="format"
                            :format="dateFormat"
                            :popup-style="{ top: '100%', left: 0 }"
                            :append-to-body="false"
                          >
                          </date-picker>
                        </div>
                      </div>

                      <div class="form-group row">
                        <label class="col-md-4">{{
                          $t("form.student.dissertation")
                        }}</label>
                        <input
                          type="text"
                          class="col-md-7 form-control"
                          v-model="studentGraduateReq.DBADissertation"
                        />
                      </div>

                      <div class="form-group row">
                        <label class="col-md-4">{{
                          $t("form.student.dissertationDate")
                        }}</label>
                        <!-- <input type="text" class="col-md-7 form-control"
                                                    v-model="studentGraduateReq.DBADODDate"> -->
                        <div class="col-md-7 p-0">
                          <date-picker
                            class="date-picker"
                            :lang="lang"
                            v-model="studentGraduateReq.DBADODDate"
                            valueType="format"
                            :format="dateFormat"
                            :popup-style="{ top: '100%', left: 0 }"
                            :append-to-body="false"
                          >
                          </date-picker>
                        </div>
                      </div>

                      <div class="form-group">
                        <label>
                          <input
                            value="1"
                            @change="changeCheck($event)"
                            type="checkbox"
                            name="DBADegreeIssued"
                            v-model="studentGraduateReq.DBADegreeIssued"
                          />
                          {{ $t("form.student.degreeIssued") }}
                        </label>
                      </div>

                      <div class="form-group row">
                        <label class="col-md-4">{{
                          $t("form.student.degreeIssueDate")
                        }}</label>
                        <!-- <input type="text" class="col-md-7 form-control"
                                                    v-model="studentGraduateReq.DBADegreeIssueDate"> -->
                        <div class="col-md-7 p-0">
                          <date-picker
                            class="date-picker"
                            :lang="lang"
                            v-model="studentGraduateReq.DBADegreeIssueDate"
                            valueType="format"
                            :format="dateFormat"
                            :popup-style="{ top: '100%', left: 0 }"
                            :append-to-body="false"
                          >
                          </date-picker>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </b-tab>

              <b-tab :title="$t('form.student.tabAttachment')">
                <div class="row">
                  <div class="col-md-8">
                    <!-- <br> -->
                    <div class="table-responsive p-0">
                      <table class="table table-bordered">
                        <tr>
                          <th>{{ $t("form.student.file") }}</th>
                          <th>{{ $t("form.student.UploadTimestamp") }}</th>
                          <th>{{ $t("form.student.fileName") }}</th>
                          <th>{{ $t("form.student.fileDescription") }}</th>
                        </tr>
                        <tbody>
                          <tr
                            v-for="(file, index) in attachments"
                            v-bind:key="index"
                          >
                            <td class="text-center">
                              <i class="fa fa-file" aria-hidden="true"></i>
                            </td>
                            <td class="text-center">
                              {{ file.UploadTimestamp }}
                            </td>
                            <td>
                              {{ file.Name }}

                              |
                              <a
                                href="#"
                                @click.prevent="downloadAttachment(file)"
                                class="ml-2"
                              >
                                {{ $t("button.view") }}</a
                              >
                            </td>
                            <td>
                              <input
                                type="text"
                                class="form-control"
                                v-model="attachments[index].Description"
                              />
                            </td>
                            <td>
                              <span
                                style="color: red; cursor: pointer"
                                @click="removeAttachment(index, file)"
                              >
                                <i class="fa fa-times"></i>
                              </span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <div class="col-md-4">
                    <div class="form-group">
                      <label class="control-label" for="StatusID:">{{
                        $t("form.student.fileAttach")
                      }}</label>

                      <vue-dropzone
                        ref="myVueDropzone"
                        id="dropzone"
                        :options="attachmentDropzone"
                        @vdropzone-success="attachmentUploaded"
                        @vdropzone-error="uploadFileError"
                        @vdropzone-processing="isLoading = true"
                      >
                      </vue-dropzone>
                    </div>
                  </div>
                </div>
              </b-tab>

              <b-tab
                v-if="showApplicationTab"
                :title="$t('form.student.tabApplication')"
              >
                <div class="row" v-if="studentProgram.ProgramID">
                  <div class="col-md-12">
                    <div class="table-responsive p-0">
                      <table class="table table-bordered">
                        <thead>
                          <tr>
                            <th>{{ $t("form.student.sr") }}</th>
                            <th>{{ $t("form.student.reason") }}</th>
                            <th>{{ $t("form.student.file") }}</th>
                            <th></th>
                          </tr>
                        </thead>

                        <tbody v-if="selectedProgramCode == 'BBA'">
                          <tr>
                            <td>1</td>
                            <td>
                              <p class="font-weight-bold">
                                {{ $t("form.student.completeCurriculumVitae") }}
                              </p>
                            </td>
                            <td>
                              <vue-dropzone
                                id="cvDropzone"
                                :options="applicationDropzone"
                                @vdropzone-success="cvUploaded"
                                @vdropzone-error="uploadFileError"
                                @vdropzone-processing="isLoading = true"
                              >
                              </vue-dropzone>

                              <ul class="p-0 mt-2">
                                <li
                                  v-for="(
                                    file, index
                                  ) in studentApplication.CurriculumVitae"
                                  :key="index"
                                  class="d-flex justify-content-between"
                                >
                                  <span>{{ file.path.split("/").pop() }}</span>

                                  <a
                                    href="#"
                                    @click.prevent="
                                      removeUnsavedApplicationFile(
                                        index,
                                        file,
                                        'CurriculumVitae'
                                      )
                                    "
                                    class="text-danger"
                                    :title="$t('form.student.remove')"
                                    >X</a
                                  >
                                </li>
                              </ul>
                            </td>
                            <td>
                              <input
                                v-model="
                                  studentApplication.ValidCurriculumVitae
                                "
                                type="checkbox"
                              />
                            </td>
                          </tr>

                          <tr>
                            <td>2</td>
                            <td>
                              <p class="font-weight-bold">
                                {{ $t("form.student.certifiedCopyHighSchool") }}
                              </p>
                            </td>
                            <td>
                              <vue-dropzone
                                id="degreeDropzone"
                                :options="applicationDropzone"
                                @vdropzone-success="degreeUploaded"
                                @vdropzone-error="uploadFileError"
                                @vdropzone-processing="isLoading = true"
                              >
                              </vue-dropzone>

                              <ul class="p-0 mt-2">
                                <li
                                  v-for="(
                                    file, index
                                  ) in studentApplication.Degree"
                                  :key="index"
                                  class="d-flex justify-content-between"
                                >
                                  <span>{{ file.path.split("/").pop() }}</span>

                                  <a
                                    href="#"
                                    @click.prevent="
                                      removeUnsavedApplicationFile(
                                        index,
                                        file,
                                        'Degree'
                                      )
                                    "
                                    class="text-danger"
                                    :title="$t('form.student.remove')"
                                    >X</a
                                  >
                                </li>
                              </ul>
                            </td>
                            <td>
                              <input
                                v-model="studentApplication.ValidDegree"
                                type="checkbox"
                              />
                            </td>
                          </tr>

                          <tr>
                            <td>3</td>
                            <td>
                              <p class="font-weight-bold">
                                {{
                                  $t("form.student.officialAcademicTranscripts")
                                }}
                              </p>
                            </td>
                            <td>
                              <vue-dropzone
                                id="transcriptDropzone"
                                :options="applicationDropzone"
                                @vdropzone-success="transcriptUploaded"
                                @vdropzone-error="uploadFileError"
                                @vdropzone-processing="isLoading = true"
                              >
                              </vue-dropzone>

                              <ul class="p-0 mt-2">
                                <li
                                  v-for="(
                                    file, index
                                  ) in studentApplication.Transcript"
                                  :key="index"
                                  class="d-flex justify-content-between"
                                >
                                  <span>{{ file.path.split("/").pop() }}</span>

                                  <a
                                    href="#"
                                    @click.prevent="
                                      removeUnsavedApplicationFile(
                                        index,
                                        file,
                                        'Transcript'
                                      )
                                    "
                                    class="text-danger"
                                    :title="$t('form.student.remove')"
                                    >X</a
                                  >
                                </li>
                              </ul>
                            </td>
                            <td>
                              <input
                                v-model="studentApplication.ValidTranscript"
                                type="checkbox"
                              />
                            </td>
                          </tr>

                          <tr>
                            <td>4</td>
                            <td>
                              <p class="font-weight-bold">
                                {{ $t("form.student.motivationLetter") }}
                              </p>
                            </td>
                            <td>
                              <vue-dropzone
                                id="letterDropzone"
                                :options="applicationDropzone"
                                @vdropzone-success="letterUploaded"
                                @vdropzone-error="uploadFileError"
                                @vdropzone-processing="isLoading = true"
                              >
                              </vue-dropzone>

                              <ul class="p-0 mt-2">
                                <li
                                  v-for="(
                                    file, index
                                  ) in studentApplication.Letter"
                                  :key="index"
                                  class="d-flex justify-content-between"
                                >
                                  <span>{{ file.path.split("/").pop() }}</span>

                                  <a
                                    href="#"
                                    @click.prevent="
                                      removeUnsavedApplicationFile(
                                        index,
                                        file,
                                        'Letter'
                                      )
                                    "
                                    class="text-danger"
                                    :title="$t('form.student.remove')"
                                    >X</a
                                  >
                                </li>
                              </ul>
                            </td>
                            <td>
                              <input
                                v-model="studentApplication.ValidLetter"
                                type="checkbox"
                              />
                            </td>
                          </tr>

                          <tr>
                            <td>5</td>
                            <td>
                              <p class="font-weight-bold">
                                {{ $t("form.student.aSatScore") }}
                              </p>
                            </td>
                            <td>
                              <input
                                type="number"
                                class="form-control"
                                v-model="studentApplication.Score"
                                required
                              />
                            </td>
                            <td></td>
                          </tr>

                          <tr>
                            <td>6</td>
                            <td>
                              <p class="font-weight-bold">
                                {{ $t("form.student.englishProficiency") }}
                              </p>
                            </td>

                            <td>
                              <vue-dropzone
                                id="pictureDropzone"
                                :options="applicationDropzone"
                                @vdropzone-success="englishProficiencyUploaded"
                                @vdropzone-error="uploadFileError"
                                @vdropzone-processing="isLoading = true"
                              >
                              </vue-dropzone>

                              <ul class="p-0 mt-2">
                                <li
                                  v-for="(
                                    file, index
                                  ) in studentApplication.EnglishProficiency"
                                  :key="index"
                                  class="d-flex justify-content-between"
                                >
                                  <span>{{ file.path.split("/").pop() }}</span>

                                  <a
                                    href="#"
                                    @click.prevent="
                                      removeUnsavedApplicationFile(
                                        index,
                                        file,
                                        'EnglishProficiency'
                                      )
                                    "
                                    class="text-danger"
                                    :title="$t('form.student.remove')"
                                    >X</a
                                  >
                                </li>
                              </ul>
                            </td>
                            <td>
                              <input
                                v-model="
                                  studentApplication.ValidEnglishProficiency
                                "
                                type="checkbox"
                              />
                            </td>
                          </tr>

                          <tr>
                            <td>7</td>
                            <td>
                              <p class="font-weight-bold">
                                {{ $t("form.student.onePicture") }}
                              </p>
                            </td>
                            <td>
                              <vue-dropzone
                                id="pictureDropzone"
                                :options="applicationDropzone"
                                @vdropzone-success="pictureUploaded"
                                @vdropzone-error="uploadFileError"
                                @vdropzone-processing="isLoading = true"
                              >
                              </vue-dropzone>

                              <ul class="p-0 mt-2">
                                <li
                                  v-for="(
                                    file, index
                                  ) in studentApplication.Picture"
                                  :key="index"
                                  class="d-flex justify-content-between"
                                >
                                  <span>{{ file.path.split("/").pop() }}</span>

                                  <a
                                    href="#"
                                    @click.prevent="
                                      removeUnsavedApplicationFile(
                                        index,
                                        file,
                                        'Picture'
                                      )
                                    "
                                    class="text-danger"
                                    :title="$t('form.student.remove')"
                                    >X</a
                                  >
                                </li>
                              </ul>
                            </td>
                            <td>
                              <input
                                v-model="studentApplication.ValidPicture"
                                type="checkbox"
                              />
                            </td>
                          </tr>
                        <tr>
                            <td>8</td>
                            <td><p class="font-weight-bold">{{$t('form.student.passportCopy')}}</p>
                              
                            </td>
                            <td>
                                <vue-dropzone id="passportDropzone"   :options="applicationDropzone" 
                                @vdropzone-success="passportUploaded" @vdropzone-error="uploadFileError"
                                 @vdropzone-processing="isLoading=true" >
                                </vue-dropzone>
                        
                                <ul class="p-0 mt-2">
                        
                                  <li
                                  v-for="(
                                    file, index
                                  ) in studentApplication.PassportCopy"
                                  :key="index"
                                  class="d-flex justify-content-between"
                                >
                                  <span>{{ file.path.split("/").pop() }}</span>
                                  <a
                                    href="#"
                                    @click.prevent="
                                      removeUnsavedApplicationFile(
                                        index,
                                        file,
                                        'PassportCopy'
                                      )
                                    "
                                    class="text-danger"
                                    :title="$t('form.student.remove')"
                                    >X</a>
                                </li>
                                </ul>
                            </td>
                            <td>
                              <input v-model="studentApplication.ValidPassportCopy" type="checkbox">
                            </td>
                        </tr>
                        <tr>
                            <td>9</td>
                            <td><p class="font-weight-bold">{{$t('form.student.permitCopy')}}</p></td>
                            <td>
                                <vue-dropzone id="permitDropzone"   :options="applicationDropzone" 
                                @vdropzone-success="permitUploaded" @vdropzone-error="uploadFileError"
                                 @vdropzone-processing="isLoading=true">
                                </vue-dropzone>
                                <ul class="p-0 mt-2">
                                  <li
                                    v-for="(
                                      file, index
                                    ) in studentApplication.PermitCopy"
                                    :key="index"
                                    class="d-flex justify-content-between"
                                  >
                                  <span v-if="file">{{ file.path.split("/").pop() }}</span>
                                  <a
                                    href="#"
                                    @click.prevent="
                                      removeUnsavedApplicationFile(
                                        index,
                                        file,
                                        'PermitCopy'
                                      )
                                    "
                                    class="text-danger"
                                    :title="$t('form.student.remove')"
                                    >X</a>
                                  </li>
                                </ul>
                            </td>
                            <td>
                              <input v-model="studentApplication.ValidPermitCopy" type="checkbox">
                            </td>
                        </tr>
                        
                          <tr>
                            <td>10</td>
                            <td>
                              <p class="font-weight-bold">
                                {{ $t("form.student.additionalDocument") }}
                              </p>
                            </td>
                            <td colspan="2">
                              <vue-dropzone
                                id="pictureDropzone"
                                :options="applicationDropzoneAdditionalDocument"
                                @vdropzone-success="additionalDocumentsUploaded"
                                @vdropzone-error="uploadFileError"
                                @vdropzone-processing="isLoading = true"
                              >
                              </vue-dropzone>

                              <ul class="p-0 mt-2">
                                <li
                                  v-for="(
                                    file, index
                                  ) in studentApplication.AdditionalDocuments"
                                  :key="index"
                                  class="d-flex justify-content-between"
                                >
                                  <span>{{ file.path.split("/").pop() }}</span>
                                  <a
                                    href="#"
                                    @click.prevent="
                                      removeUnsavedApplicationFile(
                                        index,
                                        file,
                                        'AdditionalDocuments'
                                      )
                                    "
                                    class="text-danger"
                                    :title="$t('form.student.remove')"
                                    >X</a>
                                </li>
                              </ul>
                            </td>
                          </tr>
                        </tbody>
                        <tbody v-if="selectedProgramCode == 'AAE'">
                          <tr>
                            <td>1</td>
                            <td>
                              <p class="font-weight-bold">
                                {{ $t("form.student.completeCurriculumVitae") }}
                              </p>
                            </td>
                            <td>
                              <vue-dropzone
                                id="cvDropzone"
                                :options="applicationDropzone"
                                @vdropzone-success="cvUploaded"
                                @vdropzone-error="uploadFileError"
                                @vdropzone-processing="isLoading = true"
                              >
                              </vue-dropzone>

                              <ul class="p-0 mt-2">
                                <li
                                  v-for="(
                                    file, index
                                  ) in studentApplication.CurriculumVitae"
                                  :key="index"
                                  class="d-flex justify-content-between"
                                >
                                  <span>{{ file.path.split("/").pop() }}</span>

                                  <a
                                    href="#"
                                    @click.prevent="
                                      removeUnsavedApplicationFile(
                                        index,
                                        file,
                                        'CurriculumVitae'
                                      )
                                    "
                                    class="text-danger"
                                    :title="$t('form.student.remove')"
                                    >X</a
                                  >
                                </li>
                              </ul>
                            </td>
                            <td>
                              <input
                                v-model="
                                  studentApplication.ValidCurriculumVitae
                                "
                                type="checkbox"
                              />
                            </td>
                          </tr>

                          <tr>
                            <td>2</td>
                            <td>
                              <p class="font-weight-bold">
                                {{ $t("form.student.certifiedCopyHighSchool") }}
                              </p>
                            </td>
                            <td>
                              <vue-dropzone
                                id="degreeDropzone"
                                :options="applicationDropzone"
                                @vdropzone-success="degreeUploaded"
                                @vdropzone-error="uploadFileError"
                                @vdropzone-processing="isLoading = true"
                              >
                              </vue-dropzone>

                              <ul class="p-0 mt-2">
                                <li
                                  v-for="(
                                    file, index
                                  ) in studentApplication.Degree"
                                  :key="index"
                                  class="d-flex justify-content-between"
                                >
                                  <span>{{ file.path.split("/").pop() }}</span>

                                  <a
                                    href="#"
                                    @click.prevent="
                                      removeUnsavedApplicationFile(
                                        index,
                                        file,
                                        'Degree'
                                      )
                                    "
                                    class="text-danger"
                                    :title="$t('form.student.remove')"
                                    >X</a
                                  >
                                </li>
                              </ul>
                            </td>
                            <td>
                              <input
                                v-model="studentApplication.ValidDegree"
                                type="checkbox"
                              />
                            </td>
                          </tr>

                          <tr>
                            <td>3</td>
                            <td>
                              <p class="font-weight-bold">
                                {{
                                  $t("form.student.officialAcademicTranscripts")
                                }}
                              </p>
                            </td>
                            <td>
                              <vue-dropzone
                                id="transcriptDropzone"
                                :options="applicationDropzone"
                                @vdropzone-success="transcriptUploaded"
                                @vdropzone-error="uploadFileError"
                                @vdropzone-processing="isLoading = true"
                              >
                              </vue-dropzone>

                              <ul class="p-0 mt-2">
                                <li
                                  v-for="(
                                    file, index
                                  ) in studentApplication.Transcript"
                                  :key="index"
                                  class="d-flex justify-content-between"
                                >
                                  <span>{{ file.path.split("/").pop() }}</span>

                                  <a
                                    href="#"
                                    @click.prevent="
                                      removeUnsavedApplicationFile(
                                        index,
                                        file,
                                        'Transcript'
                                      )
                                    "
                                    class="text-danger"
                                    :title="$t('form.student.remove')"
                                    >X</a
                                  >
                                </li>
                              </ul>
                            </td>
                            <td>
                              <input
                                v-model="studentApplication.ValidTranscript"
                                type="checkbox"
                              />
                            </td>
                          </tr>

                          <tr>
                            <td>4</td>
                            <td>
                              <p class="font-weight-bold">
                                {{ $t("form.student.associateDegree") }}
                              </p>
                            </td>
                            <td>
                              <vue-dropzone
                                id="associateDegreeDropzone"
                                :options="applicationDropzone"
                                @vdropzone-success="associateDegreeUploaded"
                                @vdropzone-error="uploadFileError"
                                @vdropzone-processing="isLoading = true"
                              >
                              </vue-dropzone>

                              <ul class="p-0 mt-2">
                                <li
                                  v-for="(
                                    file, index
                                  ) in studentApplication.AssociateDegree"
                                  :key="index"
                                  class="d-flex justify-content-between"
                                >
                                  <span>{{ file.path.split("/").pop() }}</span>

                                  <a
                                    href="#"
                                    @click.prevent="
                                      removeUnsavedApplicationFile(
                                        index,
                                        file,
                                        'AssociateDegree'
                                      )
                                    "
                                    class="text-danger"
                                    :title="$t('form.student.remove')"
                                    >X</a
                                  >
                                </li>
                              </ul>
                            </td>
                            <td>
                              <input
                                v-model="
                                  studentApplication.ValidAssociateDegree
                                "
                                type="checkbox"
                              />
                            </td>
                          </tr>

                          <tr>
                            <td>5</td>
                            <td>
                              <p class="font-weight-bold">
                                {{ $t("form.student.aSatScore") }}
                              </p>
                            </td>
                            <td>
                              <input
                                type="number"
                                class="form-control"
                                v-model="studentApplication.Score"
                                required
                              />
                            </td>
                            <td></td>
                          </tr>

                          <tr>
                            <td>6</td>
                            <td>
                              <p class="font-weight-bold">
                                {{ $t("form.student.englishProficiency") }}
                              </p>
                            </td>

                            <td>
                              <vue-dropzone
                                id="pictureDropzone"
                                :options="applicationDropzone"
                                @vdropzone-success="englishProficiencyUploaded"
                                @vdropzone-error="uploadFileError"
                                @vdropzone-processing="isLoading = true"
                              >
                              </vue-dropzone>

                              <ul class="p-0 mt-2">
                                <li
                                  v-for="(
                                    file, index
                                  ) in studentApplication.EnglishProficiency"
                                  :key="index"
                                  class="d-flex justify-content-between"
                                >
                                  <span>{{ file.path.split("/").pop() }}</span>

                                  <a
                                    href="#"
                                    @click.prevent="
                                      removeUnsavedApplicationFile(
                                        index,
                                        file,
                                        'EnglishProficiency'
                                      )
                                    "
                                    class="text-danger"
                                    :title="$t('form.student.remove')"
                                    >X</a
                                  >
                                </li>
                              </ul>
                            </td>
                            <td>
                              <input
                                v-model="
                                  studentApplication.ValidEnglishProficiency
                                "
                                type="checkbox"
                              />
                            </td>
                          </tr>

                          <tr>
                            <td>7</td>
                            <td>
                              <p class="font-weight-bold">
                                {{ $t("form.student.onePicture") }}
                              </p>
                            </td>
                            <td>
                              <vue-dropzone
                                id="pictureDropzone"
                                :options="applicationDropzone"
                                @vdropzone-success="pictureUploaded"
                                @vdropzone-error="uploadFileError"
                                @vdropzone-processing="isLoading = true"
                              >
                              </vue-dropzone>

                              <ul class="p-0 mt-2">
                                <li
                                  v-for="(
                                    file, index
                                  ) in studentApplication.Picture"
                                  :key="index"
                                  class="d-flex justify-content-between"
                                >
                                  <span>{{ file.path.split("/").pop() }}</span>

                                  <a
                                    href="#"
                                    @click.prevent="
                                      removeUnsavedApplicationFile(
                                        index,
                                        file,
                                        'Picture'
                                      )
                                    "
                                    class="text-danger"
                                    :title="$t('form.student.remove')"
                                    >X</a
                                  >
                                </li>
                              </ul>
                            </td>
                            <td>
                              <input
                                v-model="studentApplication.ValidPicture"
                                type="checkbox"
                              />
                            </td>
                          </tr>

                          <tr>
                            <td>8</td>
                            <td><p class="font-weight-bold">{{$t('form.student.passportCopy')}}</p>
                              
                            </td>
                            <td>
                                <vue-dropzone id="passportDropzone"   :options="applicationDropzone" 
                                @vdropzone-success="passportUploaded" @vdropzone-error="uploadFileError"
                                 @vdropzone-processing="isLoading=true" >
                                </vue-dropzone>
                        
                                <ul class="p-0 mt-2">
                        
                                  <li
                                  v-for="(
                                    file, index
                                  ) in studentApplication.PassportCopy"
                                  :key="index"
                                  class="d-flex justify-content-between"
                                >
                                  <span>{{ file.path.split("/").pop() }}</span>
                                  <a
                                    href="#"
                                    @click.prevent="
                                      removeUnsavedApplicationFile(
                                        index,
                                        file,
                                        'PassportCopy'
                                      )
                                    "
                                    class="text-danger"
                                    :title="$t('form.student.remove')"
                                    >X</a>
                                </li>
                                </ul>
                            </td>
                            <td>
                              <input v-model="studentApplication.ValidPassportCopy" type="checkbox">
                          </td>
                        </tr>
                        <tr>
                            <td>9</td>
                            <td><p class="font-weight-bold">{{$t('form.student.permitCopy')}}</p></td>
                            <td>
                                <vue-dropzone id="permitDropzone"   :options="applicationDropzone" 
                                @vdropzone-success="permitUploaded" @vdropzone-error="uploadFileError"
                                 @vdropzone-processing="isLoading=true">
                                </vue-dropzone>
                                <ul class="p-0 mt-2">
                                  <li
                                    v-for="(
                                      file, index
                                    ) in studentApplication.PermitCopy"
                                    :key="index"
                                    class="d-flex justify-content-between"
                                  >
                                  <span v-if="file">{{ file.path.split("/").pop() }}</span>
                                  <a
                                    href="#"
                                    @click.prevent="
                                      removeUnsavedApplicationFile(
                                        index,
                                        file,
                                        'PermitCopy'
                                      )
                                    "
                                    class="text-danger"
                                    :title="$t('form.student.remove')"
                                    >X</a>
                                  </li>
                                </ul>
                            </td>
                            <td>
                              <input v-model="studentApplication.ValidPermitCopy" type="checkbox">
                          </td>
                        </tr>

                          <tr>
                            <td>10</td>
                            <td>
                              <p class="font-weight-bold">
                                {{ $t("form.student.additionalDocument") }}
                              </p>
                            </td>
                            <td colspan="2">
                              <vue-dropzone
                                id="pictureDropzone"
                                :options="applicationDropzoneAdditionalDocument"
                                @vdropzone-success="additionalDocumentsUploaded"
                                @vdropzone-error="uploadFileError"
                                @vdropzone-processing="isLoading = true"
                              >
                              </vue-dropzone>

                              <ul class="p-0 mt-2">
                                <li
                                  v-for="(
                                    file, index
                                  ) in studentApplication.AdditionalDocuments"
                                  :key="index"
                                  class="d-flex justify-content-between"
                                >
                                  <span>{{ file.split("/").pop() }}</span>
                                  <a
                                    href="#"
                                    @click.prevent="
                                      removeUnsavedApplicationFile(
                                        index,
                                        file,
                                        'AdditionalDocuments'
                                      )
                                    "
                                    class="text-danger"
                                    :title="$t('form.student.remove')"
                                    >X</a
                                  >
                                </li>
                              </ul>
                            </td>
                          </tr>
                        </tbody>

                        <tbody
                          v-if="
                            selectedProgramCode == 'MSc' ||
                            selectedProgramCode == 'MBA' ||
                            selectedProgramCode == 'EMBA'
                          "
                        >
                          <tr>
                            <td>1</td>
                            <td>
                              <p class="font-weight-bold">
                                {{ $t("form.student.completeCurriculumVitae") }}
                              </p>
                            </td>
                            <td>
                              <vue-dropzone
                                id="cvDropzone"
                                :options="applicationDropzone"
                                @vdropzone-success="cvUploaded"
                                @vdropzone-error="uploadFileError"
                                @vdropzone-processing="isLoading = true"
                              >
                              </vue-dropzone>

                              <ul class="p-0 mt-2">
                                <li
                                  v-for="(
                                    file, index
                                  ) in studentApplication.CurriculumVitae"
                                  :key="index"
                                  class="d-flex justify-content-between"
                                >
                                  <span>{{ file.path.split("/").pop() }}</span>

                                  <a
                                    href="#"
                                    @click.prevent="
                                      removeUnsavedApplicationFile(
                                        index,
                                        file,
                                        'CurriculumVitae'
                                      )
                                    "
                                    class="text-danger"
                                    :title="$t('form.student.remove')"
                                    >X</a
                                  >
                                </li>
                              </ul>
                            </td>
                            <td>
                              <input
                                v-model="
                                  studentApplication.ValidCurriculumVitae
                                "
                                type="checkbox"
                              />
                            </td>
                          </tr>

                          <tr>
                            <td>2</td>
                            <td>
                              <p class="font-weight-bold">
                                {{ $t("form.student.certifiedCopyBachelor") }}
                              </p>
                            </td>
                            <td>
                              <vue-dropzone
                                id="degreeDropzone"
                                :options="applicationDropzone"
                                @vdropzone-success="degreeUploaded"
                                @vdropzone-error="uploadFileError"
                                @vdropzone-processing="isLoading = true"
                              >
                              </vue-dropzone>

                              <ul class="p-0 mt-2">
                                <li
                                  v-for="(
                                    file, index
                                  ) in studentApplication.Degree"
                                  :key="index"
                                  class="d-flex justify-content-between"
                                >
                                  <span>{{ file.path.split("/").pop() }}</span>

                                  <a
                                    href="#"
                                    @click.prevent="
                                      removeUnsavedApplicationFile(
                                        index,
                                        file,
                                        'Degree'
                                      )
                                    "
                                    class="text-danger"
                                    :title="$t('form.student.remove')"
                                    >X</a
                                  >
                                </li>
                              </ul>
                            </td>
                            <td>
                              <input
                                v-model="studentApplication.ValidDegree"
                                type="checkbox"
                              />
                            </td>
                          </tr>

                          <tr>
                            <td>3</td>
                            <td>
                              <p class="font-weight-bold">
                                {{
                                  $t("form.student.officialAcademicTranscripts")
                                }}
                              </p>
                            </td>
                            <td>
                              <vue-dropzone
                                id="transcriptDropzone"
                                :options="applicationDropzone"
                                @vdropzone-success="transcriptUploaded"
                                @vdropzone-error="uploadFileError"
                                @vdropzone-processing="isLoading = true"
                              >
                              </vue-dropzone>

                              <ul class="p-0 mt-2">
                                <li
                                  v-for="(
                                    file, index
                                  ) in studentApplication.Transcript"
                                  :key="index"
                                  class="d-flex justify-content-between"
                                >
                                  <span>{{ file.path.split("/").pop() }}</span>

                                  <a
                                    href="#"
                                    @click.prevent="
                                      removeUnsavedApplicationFile(
                                        index,
                                        file,
                                        'Transcript'
                                      )
                                    "
                                    class="text-danger"
                                    :title="$t('form.student.remove')"
                                    >X</a
                                  >
                                </li>
                              </ul>
                            </td>
                            <td>
                              <input
                                v-model="studentApplication.ValidTranscript"
                                type="checkbox"
                              />
                            </td>
                          </tr>

                          <tr>
                            <td>4</td>
                            <td>
                              <p class="font-weight-bold">
                                {{ $t("form.student.twoReferenceLetters") }}
                              </p>
                            </td>
                            <td>
                              <vue-dropzone
                                id="letterDropzone"
                                :options="applicationDropzone"
                                @vdropzone-success="letterUploaded"
                                @vdropzone-error="uploadFileError"
                                @vdropzone-processing="isLoading = true"
                              >
                              </vue-dropzone>

                              <ul class="p-0 mt-2">
                                <li
                                  v-for="(
                                    file, index
                                  ) in studentApplication.Letter"
                                  :key="index"
                                  class="d-flex justify-content-between"
                                >
                                  <span>{{ file.path.split("/").pop() }}</span>

                                  <a
                                    href="#"
                                    @click.prevent="
                                      removeUnsavedApplicationFile(
                                        index,
                                        file,
                                        'Letter'
                                      )
                                    "
                                    class="text-danger"
                                    :title="$t('form.student.remove')"
                                    >X</a
                                  >
                                </li>
                              </ul>
                            </td>
                            <td>
                              <input
                                v-model="studentApplication.ValidLetter"
                                type="checkbox"
                              />
                            </td>
                          </tr>

                          <tr>
                            <td>5</td>
                            <td>
                              <p class="font-weight-bold">
                                {{ $t("form.student.onePicture") }}
                              </p>
                            </td>
                            <td>
                              <vue-dropzone
                                id="pictureDropzone"
                                :options="applicationDropzone"
                                @vdropzone-success="pictureUploaded"
                                @vdropzone-error="uploadFileError"
                                @vdropzone-processing="isLoading = true"
                              >
                              </vue-dropzone>

                              <ul class="p-0 mt-2">
                                <li
                                  v-for="(
                                    file, index
                                  ) in studentApplication.Picture"
                                  :key="index"
                                  class="d-flex justify-content-between"
                                >
                                  <span>{{ file.path.split("/").pop() }}</span>

                                  <a
                                    href="#"
                                    @click.prevent="
                                      removeUnsavedApplicationFile(
                                        index,
                                        file,
                                        'Picture'
                                      )
                                    "
                                    class="text-danger"
                                    :title="$t('form.student.remove')"
                                    >X</a
                                  >
                                </li>
                              </ul>
                            </td>
                            <td>
                              <input
                                v-model="studentApplication.ValidPicture"
                                type="checkbox"
                              />
                            </td>
                          </tr>

                          <tr>
                            <td>6</td>
                            <td><p class="font-weight-bold">{{$t('form.student.passportCopy')}}</p>
                              
                            </td>
                            <td>
                                <vue-dropzone id="passportDropzone"   :options="applicationDropzone" 
                                @vdropzone-success="passportUploaded" @vdropzone-error="uploadFileError"
                                 @vdropzone-processing="isLoading=true" >
                                </vue-dropzone>
                        
                                <ul class="p-0 mt-2">
                        
                                  <li
                                  v-for="(
                                    file, index
                                  ) in studentApplication.PassportCopy"
                                  :key="index"
                                  class="d-flex justify-content-between"
                                >
                                  <span>{{ file.path.split("/").pop() }}</span>
                                  <a
                                    href="#"
                                    @click.prevent="
                                      removeUnsavedApplicationFile(
                                        index,
                                        file,
                                        'PassportCopy'
                                      )
                                    "
                                    class="text-danger"
                                    :title="$t('form.student.remove')"
                                    >X</a>
                                </li>
                                </ul>
                            </td>
                            <td>
                              <input v-model="studentApplication.ValidPassportCopy" type="checkbox">
                            </td>
                        </tr>
                        <tr>
                            <td>7</td>
                            <td><p class="font-weight-bold">{{$t('form.student.permitCopy')}}</p></td>
                            <td>
                                <vue-dropzone id="permitDropzone"   :options="applicationDropzone" 
                                @vdropzone-success="permitUploaded" @vdropzone-error="uploadFileError"
                                 @vdropzone-processing="isLoading=true">
                                </vue-dropzone>
                                <ul class="p-0 mt-2">
                                  <li
                                    v-for="(
                                      file, index
                                    ) in studentApplication.PermitCopy"
                                    :key="index"
                                    class="d-flex justify-content-between"
                                  >
                                  <span v-if="file">{{ file.path.split("/").pop() }}</span>
                                  <a
                                    href="#"
                                    @click.prevent="
                                      removeUnsavedApplicationFile(
                                        index,
                                        file,
                                        'PermitCopy'
                                      )
                                    "
                                    class="text-danger"
                                    :title="$t('form.student.remove')"
                                    >X</a>
                                  </li>
                                </ul>
                            </td>
                            <td>
                              <input v-model="studentApplication.ValidPermitCopy" type="checkbox">
                            </td>
                        </tr>

                          <tr>
                            <td>8</td>
                            <td>
                              <p class="font-weight-bold">
                                {{ $t("form.student.additionalDocument") }}
                              </p>
                            </td>
                            <td colspan="2">
                              <vue-dropzone
                                id="pictureDropzone"
                                :options="applicationDropzoneAdditionalDocument"
                                @vdropzone-success="additionalDocumentsUploaded"
                                @vdropzone-error="uploadFileError"
                                @vdropzone-processing="isLoading = true"
                              >
                              </vue-dropzone>

                              <ul class="p-0 mt-2">
                                <li
                                  v-for="(
                                    file, index
                                  ) in studentApplication.AdditionalDocuments"
                                  :key="index"
                                  class="d-flex justify-content-between"
                                >
                                  <span>{{ file.path.split("/").pop() }}</span>
                                  <a
                                    href="#"
                                    @click.prevent="
                                      removeUnsavedApplicationFile(
                                        index,
                                        file,
                                        'AdditionalDocuments'
                                      )
                                    "
                                    class="text-danger"
                                    :title="$t('form.student.remove')"
                                    >X</a
                                  >
                                </li>
                              </ul>
                            </td>
                          </tr>
                        </tbody>

                        <tbody v-if="selectedProgramCode == 'DBA'">
                          <tr>
                            <td>1</td>
                            <td>
                              <p class="font-weight-bold">
                                {{ $t("form.student.completeCurriculumVitae") }}
                              </p>
                            </td>
                            <td>
                              <vue-dropzone
                                id="cvDropzone"
                                :options="applicationDropzone"
                                @vdropzone-success="cvUploaded"
                                @vdropzone-error="uploadFileError"
                                @vdropzone-processing="isLoading = true"
                              >
                              </vue-dropzone>

                              <ul class="p-0 mt-2">
                                <li
                                  v-for="(
                                    file, index
                                  ) in studentApplication.CurriculumVitae"
                                  :key="index"
                                  class="d-flex justify-content-between"
                                >
                                  <span>{{ file.path.split("/").pop() }}</span>

                                  <a
                                    href="#"
                                    @click.prevent="
                                      removeUnsavedApplicationFile(
                                        index,
                                        file,
                                        'CurriculumVitae'
                                      )
                                    "
                                    class="text-danger"
                                    :title="$t('form.student.remove')"
                                    >X</a
                                  >
                                </li>
                              </ul>
                            </td>
                            <td>
                              <input
                                v-model="
                                  studentApplication.ValidCurriculumVitae
                                "
                                type="checkbox"
                              />
                            </td>
                          </tr>

                          <tr>
                            <td>2</td>
                            <td>
                              <p class="font-weight-bold">
                                {{ $t("form.student.certifiedCopyMaster") }}
                              </p>
                            </td>
                            <td>
                              <vue-dropzone
                                id="degreeDropzone"
                                :options="applicationDropzone"
                                @vdropzone-success="degreeUploaded"
                                @vdropzone-error="uploadFileError"
                                @vdropzone-processing="isLoading = true"
                              >
                              </vue-dropzone>

                              <ul class="p-0 mt-2">
                                <li
                                  v-for="(
                                    file, index
                                  ) in studentApplication.Degree"
                                  :key="index"
                                  class="d-flex justify-content-between"
                                >
                                  <span
                                    ><span>{{
                                      file.path.split("/").pop()
                                    }}</span></span
                                  >

                                  <a
                                    href="#"
                                    @click.prevent="
                                      removeUnsavedApplicationFile(
                                        index,
                                        file,
                                        'Degree'
                                      )
                                    "
                                    class="text-danger"
                                    :title="$t('form.student.remove')"
                                    >X</a
                                  >
                                </li>
                              </ul>
                            </td>
                            <td>
                              <input
                                v-model="studentApplication.ValidDegree"
                                type="checkbox"
                              />
                            </td>
                          </tr>

                          <tr>
                            <td>3</td>
                            <td>
                              <p class="font-weight-bold">
                                {{
                                  $t("form.student.officialAcademicTranscripts")
                                }}
                              </p>
                            </td>
                            <td>
                              <vue-dropzone
                                id="transcriptDropzone"
                                :options="applicationDropzone"
                                @vdropzone-success="transcriptUploaded"
                                @vdropzone-error="uploadFileError"
                                @vdropzone-processing="isLoading = true"
                              >
                              </vue-dropzone>

                              <ul class="p-0 mt-2">
                                <li
                                  v-for="(
                                    file, index
                                  ) in studentApplication.Transcript"
                                  :key="index"
                                  class="d-flex justify-content-between"
                                >
                                  <span
                                    ><span>{{
                                      file.path.split("/").pop()
                                    }}</span></span
                                  >

                                  <a
                                    href="#"
                                    @click.prevent="
                                      removeUnsavedApplicationFile(
                                        index,
                                        file,
                                        'Transcript'
                                      )
                                    "
                                    class="text-danger"
                                    :title="$t('form.student.remove')"
                                    >X</a
                                  >
                                </li>
                              </ul>
                            </td>
                            <td>
                              <input
                                v-model="studentApplication.ValidTranscript"
                                type="checkbox"
                              />
                            </td>
                          </tr>

                          <tr>
                            <td>4</td>
                            <td>
                              <p class="font-weight-bold">
                                {{
                                  $t(
                                    "form.student.employmentConfirmationLetter"
                                  )
                                }}
                              </p>
                            </td>
                            <td>
                              <vue-dropzone
                                id="letterDropzone"
                                :options="applicationDropzone"
                                @vdropzone-success="letterUploaded"
                                @vdropzone-error="uploadFileError"
                                @vdropzone-processing="isLoading = true"
                              >
                              </vue-dropzone>

                              <ul class="p-0 mt-2">
                                <li
                                  v-for="(
                                    file, index
                                  ) in studentApplication.Letter"
                                  :key="index"
                                  class="d-flex justify-content-between"
                                >
                                  <span
                                    ><span>{{
                                      file.path.split("/").pop()
                                    }}</span></span
                                  >

                                  <a
                                    href="#"
                                    @click.prevent="
                                      removeUnsavedApplicationFile(
                                        index,
                                        file,
                                        'Letter'
                                      )
                                    "
                                    class="text-danger"
                                    :title="$t('form.student.remove')"
                                    >X</a
                                  >
                                </li>
                              </ul>
                            </td>
                            <td>
                              <input
                                v-model="studentApplication.ValidLetter"
                                type="checkbox"
                              />
                            </td>
                          </tr>

                          <tr>
                            <td>5</td>
                            <td>
                              <p class="font-weight-bold">
                                {{ $t("form.student.onePicture") }}
                              </p>
                            </td>
                            <td>
                              <vue-dropzone
                                id="pictureDropzone"
                                :options="applicationDropzone"
                                @vdropzone-success="pictureUploaded"
                                @vdropzone-error="uploadFileError"
                                @vdropzone-processing="isLoading = true"
                              >
                              </vue-dropzone>

                              <ul class="p-0 mt-2">
                                <li
                                  v-for="(
                                    file, index
                                  ) in studentApplication.Picture"
                                  :key="index"
                                  class="d-flex justify-content-between"
                                >
                                  <span>{{ file.path.split("/").pop() }}</span>

                                  <a
                                    href="#"
                                    @click.prevent="
                                      removeUnsavedApplicationFile(
                                        index,
                                        file,
                                        'Picture'
                                      )
                                    "
                                    class="text-danger"
                                    :title="$t('form.student.remove')"
                                    >X</a
                                  >
                                </li>
                              </ul>
                            </td>
                            <td>
                              <input
                                v-model="studentApplication.ValidPicture"
                                type="checkbox"
                              />
                            </td>
                          </tr>

                          <tr>
                            <td>6</td>
                            <td>
                              <p class="font-weight-bold">
                                {{ $t("form.student.researchInterestOutline") }}
                              </p>
                            </td>
                            <td>
                              <vue-dropzone
                                id="outlineDropzone"
                                :options="applicationDropzone"
                                @vdropzone-success="outlineUploaded"
                                @vdropzone-error="uploadFileError"
                                @vdropzone-processing="isLoading = true"
                              >
                              </vue-dropzone>

                              <ul class="p-0 mt-2">
                                <li
                                  v-for="(
                                    file, index
                                  ) in studentApplication.ResearchInterestOutline"
                                  :key="index"
                                  class="d-flex justify-content-between"
                                >
                                  <span>{{ file.path.split("/").pop() }}</span>

                                  <a
                                    href="#"
                                    @click.prevent="
                                      removeUnsavedApplicationFile(
                                        index,
                                        file,
                                        'ResearchInterestOutline'
                                      )
                                    "
                                    class="text-danger"
                                    :title="$t('form.student.remove')"
                                    >X</a
                                  >
                                </li>
                              </ul>
                            </td>
                            <td>
                              <input
                                v-model="
                                  studentApplication.ValidResearchInterestOutline
                                "
                                type="checkbox"
                              />
                            </td>
                          </tr>

                          <tr>
                            <td>7</td>
                            <td><p class="font-weight-bold">{{$t('form.student.passportCopy')}}</p>
                              
                            </td>
                            <td>
                                <vue-dropzone id="passportDropzone"   :options="applicationDropzone" 
                                @vdropzone-success="passportUploaded" @vdropzone-error="uploadFileError"
                                 @vdropzone-processing="isLoading=true" >
                                </vue-dropzone>
                        
                                <ul class="p-0 mt-2">
                        
                                  <li
                                  v-for="(
                                    file, index
                                  ) in studentApplication.PassportCopy"
                                  :key="index"
                                  class="d-flex justify-content-between"
                                >
                                  <span>{{ file.path.split("/").pop() }}</span>
                                  <a
                                    href="#"
                                    @click.prevent="
                                      removeUnsavedApplicationFile(
                                        index,
                                        file,
                                        'PassportCopy'
                                      )
                                    "
                                    class="text-danger"
                                    :title="$t('form.student.remove')"
                                    >X</a>
                                </li>
                                </ul>
                            </td>
                            <td>
                              <input v-model="studentApplication.ValidPassportCopy" type="checkbox">
                            </td>
                        </tr>

                        <tr>
                            <td>8</td>
                            <td><p class="font-weight-bold">{{$t('form.student.permitCopy')}}</p></td>
                            <td>
                                <vue-dropzone id="permitDropzone"   :options="applicationDropzone" 
                                @vdropzone-success="permitUploaded" @vdropzone-error="uploadFileError"
                                 @vdropzone-processing="isLoading=true">
                                </vue-dropzone>
                                <ul class="p-0 mt-2">
                                  <li
                                    v-for="(
                                      file, index
                                    ) in studentApplication.PermitCopy"
                                    :key="index"
                                    class="d-flex justify-content-between"
                                  >
                                  <span v-if="file">{{ file.path.split("/").pop() }}</span>
                                  <a
                                    href="#"
                                    @click.prevent="
                                      removeUnsavedApplicationFile(
                                        index,
                                        file,
                                        'PermitCopy'
                                      )
                                    "
                                    class="text-danger"
                                    :title="$t('form.student.remove')"
                                    >X</a>
                                  </li>
                                </ul>
                            </td>
                            <td>
                              <input v-model="studentApplication.ValidPermitCopy" type="checkbox">
                            </td>
                        </tr>

                          <tr>
                            <td>9</td>
                            <td>
                              <p class="font-weight-bold">
                                {{ $t("form.student.additionalDocument") }}
                              </p>
                            </td>
                            <td colspan="2">
                              <vue-dropzone
                                id="pictureDropzone"
                                :options="applicationDropzoneAdditionalDocument"
                                @vdropzone-success="additionalDocumentsUploaded"
                                @vdropzone-error="uploadFileError"
                                @vdropzone-processing="isLoading = true"
                              >
                              </vue-dropzone>

                              <ul class="p-0 mt-2">
                                <li
                                  v-for="(
                                    file, index
                                  ) in studentApplication.AdditionalDocuments"
                                  :key="index"
                                  class="d-flex justify-content-between"
                                >
                                  <span>{{ file.path.split("/").pop() }}</span>
                                  <a
                                    href="#"
                                    @click.prevent="
                                      removeUnsavedApplicationFile(
                                        index,
                                        file,
                                        'AdditionalDocuments'
                                      )
                                    "
                                    class="text-danger"
                                    :title="$t('form.student.remove')"
                                    >X</a
                                  >
                                </li>
                              </ul>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vue2Dropzone from "vue2-dropzone";
import Summernote from "../../components/Summernote";

/**
 * Vuelidate items
 */
import {
  required,
  minLength,
  maxLength,
  between,
  alpha,
  alphaNum,
  numeric,
  decimal,
  email,
} from "vuelidate/lib/validators";

export default {
  props: ["permissions", "dateFormat", "user"],

  components: {
    vueDropzone: vue2Dropzone,
    Summernote,
  },

  data() {
    return {
      isInvalidDate2:'',isInvalidDate:'',
      isLoading: false,
      fullPage: true,

      alert: false,
      alertClass: "",
      alertMessage: "",

      lang: {
        formatLocale: {
          firstDayOfWeek: 1,
        },
      },

      noGradingScale: false,

      requestSource: "",
      invalidStudentCountry: false,
      image: "/images/student.jpg",
      programCodesSecondaryMajor: [],

      attachmentDropzone: {
        url: "/api/students/attachments",
        headers: {
          "X-CSRF-TOKEN":
            document.head.querySelector("[name=csrf-token]").content,
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
        thumbnailWidth: 150, // px
        thumbnailHeight: 150,
        params: {
          student:  localStorage.getItem("get-student")// Replace 123 with the actual student number value
        }
      },

      profileDropzone: {
        language: {
          dictDefaultMessage:
            "Drop a PDF file here, or click to select a file to upload.",
        },
        url: "/api/students/profile-image",
        headers: {
          "X-CSRF-TOKEN":
            document.head.querySelector("[name=csrf-token]").content,
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
        thumbnailWidth: 150,
        thumbnailHeight: 150,
        addRemoveLinks: true,
        maxFiles: 1,
      },

      applicationDropzone: {
        url: "/api/students/application",
        headers: {
          "X-CSRF-TOKEN":
            document.head.querySelector("[name=csrf-token]").content,
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
        thumbnailWidth: 150, // px
        thumbnailHeight: 150,
      },

      applicationDropzoneAdditionalDocument: {
        url: "/api/students/application",
        headers: {
          "X-CSRF-TOKEN":
            document.head.querySelector("[name=csrf-token]").content,
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
        thumbnailWidth: 150, // px
        thumbnailHeight: 150,
        acceptedFiles:
          ".docx,.doc,.xls,.xlsx,.ppt,.pptx,.pdf,.zip,.jpg,.jpeg,.tiff,.bmp,.gif,.png",
      },

      status: {
        StatusID: "",
        StatusName: "",
        StatusComment: "",
        StatusDate: this.formatDate(),
      },

      selectedProgramCode: "",
      selectedProgram2Code: "",

      courses: [],
      courses2: [],
      countries: [],
      programs: [],
      secondaryPrograms: [],
      professor: [],
      grades: [],
      secondaryGrades: [],
      attachments: [],
      studentStatus: [],
      statusList: [],
      partners: [],
      partnercampus: [],
      studentAbsences: [],

      titles: [],
      descriptiveGrades: [],
      ECTSGrades: [],
      gradeType: "pr",
      gradingScale: {},

      student: {
        StudentNumber: null,
        FirstName: "",
        LastName: "",
        TranscriptName: null,
        Title: null,
        BirthDate: null,
        BirthPlace: null,
        BirthCountry: null,
        Nationality: null,
        StreetAddress: null,
        City: null,
        Zip: null,
        Country: null,
        Phone: null,
        Mobile: null,
        Fax: null,
        Email: null,
        Email2: null,
        Email3: null,
        WebAddress: null,
        Photo: null,
        Remarks: null,
        Notes: null,
        MailAddress: 1,
        Student: 1,
        Professor: 1,
        Staff: 1,
        SISEnabled: 0,
        GradeNotification: 0,
        BirthdayNotification: 1,
        PartnerID: null,
        PartnerCampusID: null,
        ImportFlag: 1,
        ImportUser: 1,
        CurrentStatus: 0,
        LegalizationRequired: 0,
        ProgramStart: null,
        MatriculationNum: null,
      },

      studentProgram: {
        ProgramID: null,
        ProgramType: "",
        Program2ID: null,
        BooksIncluded: null,
        Graduate: null,
        Withdraw: null,
        GraduationDate: null,
        ThesisPercentage: null,
        ThesisDescriptiveGrade: null,
        ThesisGrade: null,
        ThesisECTSGrade: null,
        ThesisSubject: null,
        ThesisMentor: null,
        Examiner1: null,
        Examiner2: null,
        Examiner3: null,
        Examiner4: null,
        Examiner5: null,
      },

      studentGraduateReq: {
        BBAExitSurvey: null,
        BBAExitSurveyCBE: null,

        MASExitSurvey: null,
        MASExitExamSBS: null,
        MASExitExamSBSResult: null,
        MSCInternReport: null,

        DBAExitSurvey: null,
        DBAExitExamSBS: null,
        DBAExitExamSBSResult: null,

        DBAEthicsApprovalDoc: null,
        DBAEApprovalDate: null,
        DBAStatsExamDate: null,
        DBAStatsExamResult: null,
        DBACompsDate: null,
        DBACompsResult: null,
        DBAMAIssued: null,
        DBAMADate: null,
        DBADissertation: null,
        DBADODDate: null,
        DBADegreeIssued: null,
        DBADegreeIssueDate: null,

        FinancialObligations: null,
        PassingGPA: null,
      },

      studentBussiness: {
        CompanyName: null,
        Department: null,
        Position: null,
        StreetAddress: null,
        City: null,
        Zip: null,
        Country: null,
        Phone: null,
        Mobile: null,
        Fax: null,
        Email: null,
        WebAddress: null,
        ContactPersonTitle: null,
        ContactPersonFirstName: null,
        ContactPersonLastName: null,
        ContactPersonDepartment: null,
        Notes: null,
        StudentID: null,
        ProfessorID: null,
      },

      studentAdmission: {
        EducationalBackground: null,
        SBSTest: null,
        GMATTest: null,
        GMATResult: null,
        SATTest: null,
        SATResult: null,
        TOEFLTest: null,
        TOEFLResult: null,
        IELTSTest: null,
        IELTSResult: null,
        ExamAdmBBA: null,
        ExamAdmResultBBA: null,
        ExamEntBBA: null,
        ExamEntResultBBA: null,
        ExamOthBBA: null,
        ExamOthResultBBA: null,
        ExamAdmMAS: null,
        ExamAdmResultMAS: null,
        ExamEntMAS: null,
        ExamEntResultMAS: null,
        ExamOthMAS: null,
        ExamOthResultMAS: null,
        ExamEntDBA: null,
        ExamEntResultDBA: null,
        ExamOthDBA: null,
        ExamOthResultDBA: null,
      },

      studentAbsence: {
        Date: null,
        Reason: null,
        Course: null,
        Remarks: null,
      },

      studentApplication: {
        CurriculumVitae: [],
        Degree: [],
        Transcript: [],
        Letter: [],
        Picture: [],
        PassportCopy: [],
        PermitCopy: [],
        AdditionalDocuments: [],
        Score: "",
        EnglishProficiency: [],
        ResearchInterestOutline: [],
        AssociateDegree: [],
        ValidPassportCopy: false,
        ValidPermitCopy: false,
        ValidAssociateDegree: false,
        ValidResearchInterestOutline: false,
        ValidCurriculumVitae: false,
        ValidDegree: false,
        ValidTranscript: false,
        ValidLetter: false,
        ValidPicture: false,
        ValidEnglishProficiency: false,
      },
    };
  },

  validations: {
    student: {
      FirstName: {
        required,
        maxLength: maxLength(100),
      },
      LastName: {
        required,
        maxLength: maxLength(100),
      },
      BirthPlace: {
       
        maxLength: maxLength(100),
      },

      Email: {
        required,
        email,
      },
      MatriculationNum: {
        maxLength: maxLength(50),
        // regular expression to allow dashes
        pattern: value => /^[-\w]+$/i.test(value),
      },
    },

    studentBussiness: {
      CompanyName: {
        required,
        maxLength: maxLength(100),
      },
      Department: {
        required,
        maxLength: maxLength(100),
      },
      Position: {
        required,
        maxLength: maxLength(100),
      },
      StreetAddress: {
        required,
        maxLength: maxLength(255),
      },
      City: {
        required,
        maxLength: maxLength(100),
      },
      Country: {
        required,
      },
      Zip: {
        required,
        maxLength: maxLength(50),
      },
      Phone: {
        required,
        maxLength: maxLength(100),
      },
      Mobile: {
        required,
        maxLength: maxLength(100),
      },
      Email: {
        required,
        email,
      },
      ContactPersonFirstName: {
        maxLength: maxLength(100),
      },
      ContactPersonLastName: {
        maxLength: maxLength(100),
      },
      ContactPersonDepartment: {
        maxLength: maxLength(100),
      },
    },

    studentProgram: {
      ProgramID: {
        required,
        numeric,
        maxLength: maxLength(255),
      },
      ThesisSubject: {
        maxLength: maxLength(255),
      },
      ThesisPercentage: {
        numeric,
        maxLength: maxLength(10),
      },
    },

    grades: {
      $each: {
        Percentage: {
          between: between(0, 100),
        },
        Grade: {
          between: between(0, 4),
        },
      },
    },

    secondaryGrades: {
      $each: {
        Percentage: {
          between: between(0, 100),
        },
        Grade: {
          between: between(0, 4),
        },
      },
    },
  },

  mounted() {
    /**
     * Redirect back to Home if no Permission
     */
    if (!this.permissions.createStudents) {
      return this.$router.push("/");
    }

    /**
     * Initial Data for Student Form
     */
    this.getInitialData();
  },

  watch: {
    "student.FirstName": function (val) {
      this.student.TranscriptName = `${val} ${this.student.LastName}`;
    },

    "student.LastName": function (val) {
      this.student.TranscriptName = `${this.student.FirstName} ${val}`;
    },

  },

  computed: {
    showGradesBtns() {
      return (
        this.studentProgram.ProgramID &&
        (this.permissions.editPrograms || this.permissions.editStudentsGrades)
      );
    },

    isFrontOfficeUser() {
      if (this.user.roles) {
        let found = this.user.roles.find((role) => role.slug == "front.office");

        if (found) return true;
      }

      return false;
    },

    isRecruitmentManagerUser() {
      if (this.user.roles) {
        let found = this.user.roles.find(
          (role) => role.slug == "recruitment.manager"
        );

        if (found) return true;
      }

      return false;
    },

    showApplicationTab() {
      return showApplicationTab(this.user.roles);
    },
  },

  methods: {
    onChangePassportExpiryDate(){
      
      let value = this.student.PassportExpiry;
      if (!value || value ==null) {
          // Value is not set, so return true to pass the validation
          return this.isInvalidDate= "";
        }
      // Convert input date string to moment object and format to "YYYY-MM-DD" format
      const inputDate = moment(value, "DD.MM.YYYY").format("YYYY-MM-DD");
      // Get current date as moment object
      const currentDate = moment();
      // Calculate the difference in months between the two dates
      const diffInMonths = moment(inputDate).diff(currentDate, "months");
      if(diffInMonths<=1  ){
        console.log("if");
        return this.isInvalidDate= "is-invalid";
      }
      this.isInvalidDate= "";

    },  
    onChangePermitExpiryDate(){
      
      let value = this.student.PermitExpiry;
      if (!value || value ==null) {
          // Value is not set, so return true to pass the validation
          return this.isInvalidDate2= "";
      }
      // Convert input date string to moment object and format to "YYYY-MM-DD" format
      const inputDate = moment(value, "DD.MM.YYYY").format("YYYY-MM-DD");
      // Get current date as moment object
      const currentDate = moment();
      // Calculate the difference in months between the two dates
      const diffInMonths = moment(inputDate).diff(currentDate, "months");


      if(diffInMonths<=1  ){
        return this.isInvalidDate2= "is-invalid";
      }
      return this.isInvalidDate2= "";

    },
    async createToken(type) {
      let response = await axios.post("/api/api-tokens", {
        type,
      });
      let token = "";

      if (response.status == 200) {
        token = response.data.extra[0].token;
      }

      return token;
    },

    async downloadAttachment(file, isDownload = false) {
      let token = await this.createToken("student-attachment");
      if (token == "") return;
      window.open(
        `/students/attachments/${file.ID}?file=${file.File}&token=${token}&download=${isDownload}`,
        "_blank"
      );
    },

    /**
     * Go to program edit screen
     */
    editProgram() {
      if (!this.permissions.viewPrograms) return;

      localStorage.setItem("grades-tab", true);

      let id = this.studentProgram.ProgramID;

      this.$router.push({
        name: "ProgramEdit",
        params: {
          id: id,
        },
      });
    },

    /**
     * Add available program's courses to student grades
     */
    addProgramCourses() {
      // count how many coureses needs to insert into student grades
      let count = 0;

      this.courses.forEach((c) => {
        let found = this.grades.find((g) => g.CourseID == c.ID);

        if (!found) count++;
      });

      if (count == 0) {
        alert(this.$t("form.student.alreadyAssigned"));
        return;
      }

      let conf = confirm(
        this.$t("form.student.coursesCount", {
          count: count,
        })
      );

      if (conf) {
        this.courses.forEach((c) => {
          let found = this.grades.find((g) => g.CourseID == c.ID);

          if (!found) this.addGrade(c);
        });
      }
    },

    /**
     * Format Date
     */
    formatDate(format = "DD.MM.YYYY", date) {
      return moment(date).format(format);
    },

    /**
     * Set Student Profile Photo
     */
    profileUploaded(file, response) {
      this.isLoading = false;

      this.student.Photo = response.filename;
    },
    // show selecete image
    showSelectedImage() {
      let input = this.$refs.profile_image;
      let file = input.files;
      if (file && file[0]) {
        let reader = new FileReader();
        reader.onload = (e) => {
          this.image = e.target.result;
        };
        reader.readAsDataURL(file[0]);
        this.$emit("input", file[0]);
      }

      let fd = new FormData();
      fd.append("file", file[0]);
      this.isLoading = true;
      axios
        .post("/api/students/profile-image", fd)
        .then((resp) => {
          this.student.Photo = resp.data.filename;
          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
          console.log("file not found");
        });
    },

    /**
     * Upload file error on dropzone
     */
    uploadFileError(file, message) {
      this.showAlert(message.errors, "danger");
      this.isLoading = false;
    },

    /**
     * Add attachment to student attachment list
     */
    attachmentUploaded(file, response) {
      this.isLoading = false;

      this.attachments.push({
        Name: response.filename,
        File: `${response.id}/${response.filename}`,
        Description: "",
        AttachmentDate: this.formatDate(),
        UploadTimestamp: calculateTimeAsPerTimeZone("+2"),
      });
    },

    /**
     * Remove attachmemnt from student attachment list
     */
    removeAttachment(index, attach) {
      let vm = this;

      if (confirm(this.$t("form.validation.delete"))) {
        axios
          .post("/api/deleteAttachFile", attach)
          .then((response) => {
            if (response.data.error) {
              this.showAlert(response.data.message, "warning");
            } else if (response.data.success) {
              vm.attachments.splice(index, 1);
              this.showAlert(response.data.message);
            }
          })
          .catch((error) => {
            console.log("error");
          });
      }
    },

    /**
     * Application Dropzone File(s)
     */
    cvUploaded(file, response) {
      this.isLoading = false;
      var fileUploaded = {
        path: `${response.id}/${response.filename}`,
        timestamp: calculateTimeAsPerTimeZone("+2"),
      };
      this.studentApplication.CurriculumVitae.push(fileUploaded);
    },
    outlineUploaded(file, response) {
      this.isLoading = false;
      var fileUploaded = {
        path: `${response.id}/${response.filename}`,
        timestamp: calculateTimeAsPerTimeZone("+2"),
      };
      this.studentApplication.ResearchInterestOutline.push(fileUploaded);
    },
    associateDegreeUploaded(file, response) {
      this.isLoading = false;
      var fileUploaded = {
        path: `${response.id}/${response.filename}`,
        timestamp: calculateTimeAsPerTimeZone("+2"),
      };
      this.studentApplication.AssociateDegree.push(fileUploaded);
    },
    degreeUploaded(file, response) {
      this.isLoading = false;
      var fileUploaded = {
        path: `${response.id}/${response.filename}`,
        timestamp: calculateTimeAsPerTimeZone("+2"),
      };

      this.studentApplication.Degree.push(fileUploaded);
    },

    transcriptUploaded(file, response) {
      this.isLoading = false;
      var fileUploaded = {
        path: `${response.id}/${response.filename}`,
        timestamp: calculateTimeAsPerTimeZone("+2"),
      };

      this.studentApplication.Transcript.push(fileUploaded);
    },

    letterUploaded(file, response) {
      this.isLoading = false;
      var fileUploaded = {
        path: `${response.id}/${response.filename}`,
        timestamp: calculateTimeAsPerTimeZone("+2"),
      };

      this.studentApplication.Letter.push(fileUploaded);
    },

    pictureUploaded(file, response) {
      this.isLoading = false;
      var fileUploaded = {
        path: `${response.id}/${response.filename}`,
        timestamp: calculateTimeAsPerTimeZone("+2"),
      };

      this.studentApplication.Picture.push(fileUploaded);
    },

    passportUploaded(file, response) {
      this.isLoading = false;

      var fileUploaded ={
        path:response.student_number ? `${response.student_number}/${response.id}/${response.filename}` : `${response.id}/${response.filename}`,
        timestamp:calculateTimeAsPerTimeZone('+2')
      };


      this.studentApplication.PassportCopy.push(
          fileUploaded
      );

      console.log( this.studentApplication.PassportCopy[0]);
    },

    permitUploaded(file, response) {
        this.isLoading = false;
        this.studentApplication.PermitCopy = !this.studentApplication.PermitCopy? []: this.studentApplication.PermitCopy;
        var fileUploaded =
            {
                path:response.student_number ? `${response.student_number}/${response.id}/${response.filename}` : `${response.id}/${response.filename}`,
                timestamp:calculateTimeAsPerTimeZone('+2')
            };


        this.studentApplication.PermitCopy.push(
            fileUploaded
        );
        console.log( this.studentApplication.PermitCopy);
    },
    additionalDocumentsUploaded(file, response) {
      this.isLoading = false;
      this.studentApplication.AdditionalDocuments = !this.studentApplication
        .AdditionalDocuments
        ? []
        : this.studentApplication.AdditionalDocuments;
      var fileUploaded = {
        path: `${response.id}/${response.filename}`,
        timestamp: calculateTimeAsPerTimeZone("+2"),
      };

      this.studentApplication.AdditionalDocuments.push(fileUploaded);
      console.log(this.studentApplication.AdditionalDocuments);
    },
    englishProficiencyUploaded(file, response) {
      this.isLoading = false;
      var fileUploaded = {
        path: `${response.id}/${response.filename}`,
        timestamp: calculateTimeAsPerTimeZone("+2"),
      };

      this.studentApplication.EnglishProficiency.push(fileUploaded);
    },

    removeApplicationFile(index, attach, type = null) {
      let vm = this;
      const data = { path: attach };
      if (confirm(this.$t("form.validation.delete"))) {
        axios
          .post("/api/students/application/file/delete", data)
          .then((response) => {
            if (response.data.error) {
              this.showAlert(response.data.message, "warning");
            } else if (response.data.success) {
              vm.studentApplication[type].splice(index, 1);
              this.showAlert(response.data.message);
            }
          })
          .catch((error) => {
            console.log("error");
          });
      }
    },
    removeUnsavedApplicationFile(index, attach, type = null) {
      let vm = this;
      const data = { path: attach };

      vm.studentApplication[type].splice(index, 1);
      this.showAlert("deleted successfully");
    },

    /**
     * Add Selected program into student program
     */
    selectProgram(programID) {
      let program = this.programs.find((p) => p.ID === programID);

      if (!program) return;

      this.studentProgram.ProgramID = program.ID;
      this.studentProgram.ProgramType = program.ProgramType;
      this.selectedProgramCode = program.ProgramCode;

      this.getProgramCourses();
      this.getSecondaryProgram();
    },

    /**
     * Add Selected secondary program into student secondary program
     */
    selectProgram2(programID) {
      let program = this.secondaryPrograms.find((p) => p.ID === programID);

      if (!program) return;

      this.studentProgram.Program2ID = program.ID;
      this.selectedProgram2Code = program.ProgramCode;
      this.getProgramCourses("se");
    },

    /**
     * Get Program Related Courses for Student Grades Dropdown
     */
    getProgramCourses(type = "pr") {
      let id = 0;

      id =
        type == "pr"
          ? this.studentProgram.ProgramID
          : this.studentProgram.Program2ID;

      if (!id) return;

      axios
        .get(`/api/programs/${id}/courses`)
        .then((response) => {
          if (type == "pr") {
            this.courses = response.data;

            this.courses.map(
              (c) => (c.FullTitle = `${c.CourseCode} - ${c.CourseTitle}`)
            );
            this.courses2 = [];
          } else {
            this.courses2 = response.data;
            this.courses2.map(
              (c) => (c.FullTitle = `${c.CourseCode} - ${c.CourseTitle}`)
            );
          }
        })
        .catch((error) => {
          console.log(error.response);
        });
    },

    /**
     * Get Secondary Programs related to selected program
     */
    getSecondaryProgram() {
      let code = this.programCodesSecondaryMajor.find(
        (code) => code == this.selectedProgramCode
      );

      if (!code) {
        this.secondaryPrograms = [];
        return;
      }

      axios
        .get("/api/programs/secondary?code=" + code)
        .then((response) => {
          this.secondaryPrograms = response.data;
          this.secondaryPrograms = this.secondaryPrograms.map((program) => {
            program.FullTitle = this.$options.filters.program(program);

            return program;
          });

          this.isLoading = false;
        })
        .catch((error) => {
          console.log(error);
          this.isLoading = false;
        });
    },

    /**
     * Add Course to Student Grade's List
     */
    addGrade(course) {
      if (!course) return;

      //let found = this.grades.find((g) => g.CourseID == course.ID);
      const found = this.gradeType === "pr" ? this.grades.find(g => g.CourseID === course.ID) : this.secondaryGrades.find(g => g.CourseID === course.ID);

      if (found) {
        alert(this.$t("form.student.gradeExists"));
        return;
      }

      let grade = {
        CourseID: course.ID,
        FullTitle: `${course.CourseCode} - ${course.CourseTitle}`,
        Percentage: null,
        Grade: null,
        DescriptiveGrade: null,
        ECTSGrade: null,
        FinalExameDate: null,
        Enrolled: null,
      };

      this.gradeType == "pr"
        ? this.grades.push(grade)
        : this.secondaryGrades.push(grade);
    },

    /**
     * Remove Course from Student Grade's List
     */
    removeGrade(index) {
      this.grades.splice(index, 1);
    },

    /**
     * Remove Course from Student Secondary Grade's List
     */
    removeSecondaryGrade(index) {
      this.secondaryGrades.splice(index, 1);
    },

    /**
     * Add Status to Student Status List
     */
    // addStatus() {
    //     if (!this.status.StatusID) {
    //         this.showAlert(this.$t('form.validation.invalidStatus'), 'danger');
    //         return;
    //     }

    //     this.studentStatus.push({
    //         StudentStatusID: this.status.StatusID,
    //         StudentStatusName: this.status.StatusName,
    //         StudentStatusComment: this.status.StatusComment,
    //         StudentStatusDate: this.$options.filters.formatDate(this.status.StatusDate, this.dateFormat)
    //     });

    //     // reset status after add into Student Status List
    //     this.status = {
    //         StatusID: '',
    //         StatusName: '',
    //         StatusComment: '',
    //         StatusDate: this.formatDate()
    //     }
    // },

    /**
     * Remove Status from Student Status List
     */
    // removeStatus(index) {
    //     this.studentStatus.splice(index, 1);
    // },

    /**
     * Create student
     */
    createStudent() {
      this.$v.$touch();

      if (this.$v.$invalid) {
        let errorMsg = "";
        if (this.$v.student.FirstName.$error) {
          errorMsg = "FirstName";
        }

        if (this.$v.student.LastName.$error) {
          errorMsg = errorMsg ? errorMsg + ", LastName" : "LastName";
        }

        if (this.$v.student.BirthPlace.$error) {
          errorMsg = errorMsg ? errorMsg + ", BirthPlace" : "BirthPlace";
        }

        if (this.$v.student.Email.$error) {
          errorMsg = errorMsg ? errorMsg + ", Email" : "Email";
        }

        if (this.$v.studentProgram.ThesisSubject.$error) {
          errorMsg = errorMsg
            ? errorMsg + ", Thesis Subject"
            : "Thesis Subject";
        }

        if (this.$v.student.MatriculationNum.$error) {
          errorMsg = errorMsg
            ? errorMsg + ", MatriculationNum"
            : "MatriculationNum";
        }
        
        if (this.$v.studentProgram.ProgramID.$error) {
          errorMsg = errorMsg ? errorMsg + ", Program" : "Program";
        }

        if (this.$v.studentProgram.ThesisPercentage.$error) {
          errorMsg = errorMsg
            ? errorMsg + ", Thesis Percentage"
            : "Thesis Percentage";
        }

        if (this.$v.grades.$each.$error) {
          errorMsg = errorMsg
            ? errorMsg + ", Grade Percentage and Grade"
            : "Grade Percentage and Grade";
        }

        /* Custom Errors for Business Information */
        if (this.student.MailAddress == 2) {
          if (this.$v.studentBussiness.CompanyName.$error) {
            errorMsg = errorMsg
              ? errorMsg + ", Company Name (Business Information)"
              : "Company Name (Business Information)";
          }

          if (this.$v.studentBussiness.Department.$error) {
            errorMsg = errorMsg
              ? errorMsg + ", Department (Business Information)"
              : "Department (Business Information)";
          }

          if (this.$v.studentBussiness.Position.$error) {
            errorMsg = errorMsg
              ? errorMsg + ", Position (Business Information)"
              : "Position (Business Information)";
          }

          if (this.$v.studentBussiness.StreetAddress.$error) {
            errorMsg = errorMsg
              ? errorMsg + ", Street Address (Business Information)"
              : "Street Address (Business Information)";
          }

          if (this.$v.studentBussiness.City.$error) {
            errorMsg = errorMsg
              ? errorMsg + ", City (Business Information)"
              : "City (Business Information)";
          }

          if (this.$v.studentBussiness.Country.$error) {
            errorMsg = errorMsg
              ? errorMsg + ", Country (Business Information)"
              : "Country (Business Information)";
          }
          if (this.$v.studentBussiness.Zip.$error) {
            errorMsg = errorMsg
              ? errorMsg + ", Zip (Business Information)"
              : "Zip (Business Information)";
          }

          if (this.$v.studentBussiness.Phone.$error) {
            errorMsg = errorMsg
              ? errorMsg + ", Phone (Business Information)"
              : "Phone (Business Information)";
          }

          if (this.$v.studentBussiness.Mobile.$error) {
            errorMsg = errorMsg
              ? errorMsg + ", Mobile (Business Information)"
              : "Mobile (Business Information)";
          }

          if (this.$v.studentBussiness.Email.$error) {
            errorMsg = errorMsg
              ? errorMsg + ", Email (Business Information)"
              : "Email (Business Information)";
          }
        }

        if (errorMsg !== "") {
          this.showAlert(
            this.$t("form.validation.mandatoryFieldsError", {
              errors: errorMsg,
            }),
            "danger"
          );

          return;
        }
      }

      let formdata = new FormData();

      if (this.status.StatusID) {
        this.student.CurrentStatus = this.status.StatusID;

        formdata.append(
          "status[]",
          JSON.stringify({
            StudentStatusID: this.status.StatusID,
            StudentStatusName: this.status.StatusName,
            StudentStatusComment: this.status.StatusComment,
            StudentStatusDate: this.status.StatusDate,
          })
        );
      }

      // this.studentStatus.forEach(status => formdata.append("status[]", JSON.stringify(status)));
      this.grades.forEach((course) =>
        formdata.append("grades[]", JSON.stringify(course))
      );
      this.secondaryGrades.forEach((course) =>
        formdata.append("grades2[]", JSON.stringify(course))
      );
      this.attachments.forEach((attach) =>
        formdata.append("attachments[]", JSON.stringify(attach))
      );

      formdata.append("student", JSON.stringify(this.student));
      formdata.append("bussiness", JSON.stringify(this.studentBussiness));
      formdata.append("graduateReq", JSON.stringify(this.studentGraduateReq));
      formdata.append("program", JSON.stringify(this.studentProgram));
      formdata.append("admission", JSON.stringify(this.studentAdmission));
      formdata.append("application", JSON.stringify(this.studentApplication));

      this.isLoading = true;
      this.clearAlert();

      axios
        .post("/api/students", formdata)
        .then((response) => {
          this.isLoading = false;

          if (response.data.success) {
            this.showAlert(response.data.message);

            setTimeout(() => {
              this.$router.push({
                name: "StudentIndex",
              });
            }, 2000);
          }
        })
        .catch((error) => {
          this.isLoading = false;

          if (error.response.data.error) {
            this.showAlert(error.response.data.message, "danger");
          }
        });
    },

    /**
     * Show alert
     */
    showAlert(msg, cls = "success") {
      this.alertMessage = msg;
      this.alertClass = cls;
      this.alert = true;
    },

    /**
     * Clear alert
     */
    clearAlert() {
      this.alertMessage = "";
      this.alertClass = "";
      this.alert = false;
    },

    /**
     * Fetch partner campuses for selected partner
     */
    fetchPartnerCampus() {
      axios
        .get(`/api/campuses?full&PartnerID=${this.student.PartnerID}`)
        .then((response) => (this.partnercampus = response.data))
        .catch((error) => console.log("error fetching partner campuses"));
    },

    changeCheck($event) {
      if (event.target.value == 0) event.target.value = -1;
      else event.target.value = 0;
    },
    changeCreditCheck($event) {
      console.log($event.target.value);
    },

    /**
     * Get initials data for form
     */
    getInitialData() {
      axios
        .get("/api/students/initial-data")
        .then((response) => {
          let data = response.data;

          this.student.StudentNumber = data.studentNumber;
          this.partners = data.partners;
          this.countries = data.countries;
          this.titles = data.titles;
          this.descriptiveGrades = data.descriptiveGrades;
          this.ECTSGrades = data.ECTSGrades;
          this.programCodesSecondaryMajor = data.programCodes_secondaryMajor;

          if (data.grading_scale) {
            data.grading_scale.forEach(
              (gs) => (this.gradingScale[gs.ProgramCode] = gs.GradingScale)
            );
          }

          this.statusList = data.status;
          this.statusList.map((status) => {
            status.StatusComment = "";
            status.StatusDate = this.formatDate();
          });

          this.professor = data.professors;
          this.professor.map(
            (p) => (p.fullName = p.FirstName + " " + p.LastName)
          );

          this.programs = data.programs;
          this.programs.map(
            (p) => (p.FullTitle = this.$options.filters.program(p))
          );

          if (localStorage.getItem("grades-tab")) {
            this.$refs.gradesTab.activate();
            localStorage.removeItem("grades-tab");
          }
        })
        .catch((error) => console.log("error fetching initial data"));
    },

    /**
     * Clear exam after deselect related checkbox
     */
    clearExamScore() {
      if (this.studentGraduateReq.MASExitExamSBS == false) {
        this.studentGraduateReq.MASExitExamSBSResult = null;
      }
      if (this.studentGraduateReq.DBAExitExamSBS == false) {
        this.studentGraduateReq.DBAExitExamSBSResult = null;
      }
    },

    /**
     * Calculate Descriptive grades, grades and ECTS grades
     */
    applyGradingScale(grade, type = "pr") {
      let gs =
        this.gradingScale[
          type == "pr" ? this.selectedProgramCode : this.selectedProgram2Code
        ];
      this.noGradingScale = false;
      grade.FinalExameDate = this.formatDate(this.dateFormat);
      if (gs === undefined) {
        this.noGradingScale = this.$t("form.student.noGradingScale", {
          code: this.selectedProgramCode,
        });
        return;
      }

      gs.forEach((item) => {
        let min = parseFloat(item.minPercentage);
        let max = parseFloat(item.maxPercentage);
        let percentage = parseFloat(grade.Percentage);

        if (percentage >= min && percentage <= max) {
          grade.Grade = parseFloat(item.grade);
          grade.DescriptiveGrade = item.descGrade;
          // grade.ECTSGrade = item.ectsGrade;
        }
      });
    },
  },
};
</script>


<style scoped>
::-webkit-input-placeholder {
  /* Chrome/Opera/Safari */
  color: black !important;
}
::-moz-placeholder {
  /* Firefox 19+ */
  color: black !important;
}
:-ms-input-placeholder {
  /* IE 10+ */
  color: black !important;
}
:-moz-placeholder {
  /* Firefox 18- */
  color: black !important;
}

body {
  background-color: #e2e2e2;
}

#dropzone2 {
  padding: 0;
  margin: 0;
}

#dropzone2 > .dz-message,
.dropzone .dz-message {
  margin: 0 !important;
}

.custom-validate {
  display: block !important;
}

.application-list li {
  list-style-type: disc;
}

.grades-btns {
  text-align: center;
  border: 1px solid rgba(60, 60, 60, 0.26);
  padding: 2rem;
  border-radius: 5px;
}

.grades-btns button {
  width: 150px;
}
date-picker.is-invalid {
  border-color: #dc3545;
  border-style: double;
}
</style>
